<template>
  <div class="adddingdan">
    <div class="topBar">
                <div class="daohang">
                  <!-- <button @click="getMoreData">  aaa</button> -->
                            <span @click="tiaozhuan" style="cursor: pointer; font-size:20px;color:#2d8cf0;font-family:'微软雅黑' ">
                                <Icon type="ios-home"></Icon>
                            {{language.shouye}}</span>>
                            <span style="cursor: pointer; font-size:20px;font-family:'微软雅黑'" >{{language.jiagongdingdanshenqing}}</span>
                        </div>
                <div class="topBar"> 
            <div class="iptc">
                <div class="iptlis">
                  <Icon type="ios-search" class='ico'></Icon>
                  <input type="text" class="iptli" @click="srechEve()" :placeholder=language.chaxunqingdianjiwo>
                    <div class="numEve">
                      <div class="numlitter">{{language.gong}}{{numnum}}{{language.tiao}}</div></div>
                </div>
            </div>
        </div>
    </div>
        <modal class="serchlist" v-model="raval"
         width="86%" :styles="{top: '60px',left:'100px'}">
            <div class="pz">
                <Select :placeholder=language.qingxuanze type="text" v-model="numpinzhong" clearable style="width: 200px">
                    <Option v-for="item in customer"  :value="item.tuTradeUnitId">{{item.tuTradeUnitName}}</Option>
                </Select>
                <span class='pinzhongs'>{{language.shouhuokehu}}</span>
            </div>
            <!-- <div class="pz">
                <Input type="text" v-model="numpinzhong" clearable style="width: 200px"></Input>
                <span class='pinzhongs'language.shouhuokehu/span>
            </div> -->
            <!-- <div class="ph">
                <Input type="text" v-model="numpaihao" clearable style="width: 200px"></Input>
                <span class='paihaos'>品种</span>
            </div> -->
            <div class="ph">
               <Select :placeholder=language.qingxuanze type="text" v-model="numpaihao" clearable style="width: 200px">
                    <Option v-for="item in  selectDatta" :value="item" :key="item"></Option>
                </Select>
                <span class='pinzhongs'>{{language.pinzhong}}</span>
            </div>
            <!-- <div class="chxz">
                <Select :placeholder=language.qingxuanze name="" id="" v-model="cunhuo" clearable style="width: 200px">
                    <Option label="来料加工" value="LLIN">来料加工</Option>
                    <Option label="仓储" value="CCIN">仓储</Option>
                    <Option label="配送" value="PSIN">配送</Option>
                    <Option label="其他" value="QTIN">其他</Option>
                </Select>
                <span class='cunhuo'>牌号</span>
            </div> -->
            <!-- <div class="chxz">
                <Input type="text" v-model="cunhuo" clearable style="width: 200px"></Input>
                <span class='pinzhongs'>牌号</span>
            </div> -->
            <div class="chxz">
               <Select :placeholder=language.qingxuanze type="text" filterable v-model="cpyl" clearable style="width: 200px">
                    <Option v-for="item in  shopDatta" :value="item" :key="item"></Option>
                </Select>
                <span class='pinzhongs'>{{language.paihao}}</span>
            </div>
            <!-- <div class="chanpinyuanliao">
                <Select :placeholder=language.qingxuanze name="" id="" v-model="cpyl" clearable style="width: 200px">
                    <Option label="原料" value="MATERIAL">原料</Option>
                    <Option label="成品" value="PRODUCT">成品</Option>
                </Select>
                <span class='cunhuo'>原料规格</span>
            </div>  -->
            <div class="chanpinyuanliao">
                <Input :placeholder=language.qingxuanze type="text" v-model="cunhuo" clearable style="width: 200px"></Input>
                <span class='paihaos'>{{language.yuanliaoguige}}</span>
            </div>
            <div class="kunbaos">
                <Input :placeholder=language.qingxuanze type="text" v-model="numpaihaos" clearable style="width: 200px"></Input>
                <span class='paihaos'>{{language.chengpinguige}}</span>
            </div>
            <!-- <div class="kunbaos">
                <Input :placeholder=language.qingxuanze type="text" v-model="exposedNum" clearable style="width: 200px"></Input>
                <span class='paihaos'>内外板</span>
            </div> -->
            <div class="kunbaos">
                <Select :placeholder=language.qingxuanze type="text" v-model="exposedNum" clearable style="width: 200px">
                    <Option lable="10" value="10">Exposed</Option>
                    <Option lable="20" value="20">Unexposed</Option>
                </Select>
                <span class='pinzhongs'>{{language.neiwaiban}}</span>
            </div>
          <div slot="footer" style="background-color:rgb(249,249,249);height: 120px;">
                <div class="chaxun" @click='chaxun()'>{{language.chaxun}}</div>
                <div class="chongzhi" @click='chongzhis()'>{{language.chongzhi}}</div>
            </div>
      
         </modal>












    <div  class="adddingdan_change_height">
      <div :animated="false" v-model="nameTab">
        <!-- <Tab-pane  name="addpostOne" :on-click="showNameTabs(nameTab)"> -->
          <div class="add_ding_dan_sq" v-for="(item,index) in templateList" :key="index">
            <div class="add_ding_dan_shen_qing" :class="{bgc:bgc === index}" @click="showDingDanTable(item,index)">
              <p class="customerName">{{item.customerName}}</p>
              <div class="add_ding_dan_p_top">
                <p class="add_ding_dan_p_span_left">
                  <span>{{item.categoryCode}}</span><Poptip trigger="hover" :title=item.shopsign></Poptip>
                </p>
                <span class="more_text">{{item.shopsign}}</span>
                <p class="add_ding_dan_p_span_left">
                  <span>{{item.specification}}</span>
                </p>
              </div>
              <div class="add_ding_dan_shu_liang">
                (<span class="add_ding_dan_shu_liang_margin">{{item.totalprodCount}}</span><span>{{item.totalprodWeight}}</span>Kg)
              </div>
              <div class="add_ding_dan_jian_tou"><Icon type="arrow-down-a"></Icon></div>
              <div v-if= item.productList class="add_ding_dan_shen_qing_list">
                <p v-for="(items,indexs) in item.productList" :key="indexs"><span class="add_ding_dan_shen_qing_list_spes">{{items.spes}}</span><span class="add_ding_dan_shen_qing_num">{{items.firstNumbers}}</span><span class="add_ding_dan_shen_qing_weight">( {{items.allSecondQty}}  /  {{items.allPrimaryQty}}KG )</span></p>
              </div>
              <div class="add_ding_dan_jian_shu_liang">
                <span> {{item |numValue}}</span>
              </div>
              <!-- <div class="add_ding_dan_shen_qing_left">
                  <p><span class="add_ding_dan_cate">{{item.categoryCode}}</span><span>{{item.shopsign}}</span></p>
                  <p><span>{{item.totalproWeight}}</span></p>
                  <p><span>{{item.totalprodCount}}</span><span>{{item.totalprodWeight}}</span></p>
                  <div><Icon type="arrow-down-a"></Icon></div>
                  <p><span>{{item.specification}}</span></p>
              </div>
              <div v-if= item.productList class="add_ding_dan_shen_qing_right">
                  <p v-for="(items,indexs) in item.productList" :key="indexs"><span>{{items.spes}}</span></p>
              </div> -->
            </div>
            <div border class="add_ding_dan_shen_qing_table" v-if= "index === addDingDanShenQingTable">
              <Table :columns="columns1" :data="data1" border></Table>
              <!-- <div class="add_ding_dan_shen_qing_table_more_data" @click="addMoreShenQingData(item)">加载更多</div> -->
              <p class="add_ding_dan_shen_qing_table_more_data"  @click="addMoreShenQingData(item)" v-show="moredata">
              {{language.jiazaigengduo}}
            </p>
        <!-- <button @click="zhongliang">hong</button> -->
            <p class="add_ding_dan_shen_qing_table_more_data" @click="addMoreShenQingData(item)" v-show="!moredata">
              {{language.jiazaiwanbi}}
            </p>
            </div>
          </div>
        <!-- </Tab-pane> -->
        <!-- <Tab-pane label="加工订单申请查看" name="addpostTwo" >
            <Table  :columns="columns1" :data="data1"></Table>
        </Tab-pane> -->
      </div>
    </div>
<!--     <div class="add_ding_dan_sq_car">
      <div class="add_dingdan_shenqing_car" @click="showHandMove(1)">
        <span></span><Icon type="ios-compose"></Icon><p >手填加工</p>
      </div>
      <div class="add_dingdan_shenqing_car" @click="showSubmitCar">
        <span></span><Icon type="ios-cart" class=""></Icon><p >购物车</p>
      </div>
    </div> -->
      <div class="bootBanner">
            <p class="liang">
                <span>
                    <span  @click="showHandMove(1)" class="tihuoButton"><Icon type="ios-compose"></Icon>{{language.shoutianjiagong}}</span>
                </span>
                <span>
                    <span @click="showSubmitCar" class="shopButton"><Icon type="ios-cart"></Icon>{{language.gouwuche}}</span>
                </span>
            </p>
  </div>
    <!-- 购物车 -->
    <div v-show="submitCar" class="wait_submit_car">
      <div class="wait_submit_car_title" border>
        <h3>{{language.daitijiaojiagongshenqing}}</h3>
        <p @click="closeSubmitCar"><span></span><Icon type="ios-close-outline" class="closeShoping"></Icon>{{language.guanbi}}</p>
      </div>
      <Table :columns="columns2" :data="data2" border></Table>
      <div class="submit_add_car">
        <p @click="submitAddCar()">{{language.quanbutijiao}}</p>
        <p @click="removeSubmitAddCar()">{{language.qingkonggouwuche}}</p>
      </div>
    </div>

    <!-- 手填加工 -->
    <div v-show="handMove" class="hand_move_submit_car">
      <div class="hand_move_submit_car_title">
        <h3>{{language.jiagongdingdanshenqing}}</h3>
        <p @click="closehandMoveCar"><span></span>{{language.fanhui}}</p>
      </div>
      <div class="hand_move_title_car">
        <p>{{language.yuanliaochengpinxuanze}}</p>
      </div>
      <div class="hand_move_search_material">
        <p>1.{{language.qingxuanzeyuanliao}}</p>
        <div class="hand_move_search_material_news">
          <div class="hand_move_search_material_condition">
            <ul>
              <li>
                <label>{{language.pinzhong}}</label>
                <!-- <input :placeholder=language.qingxuanze  v-model="handMoveCategoryCode" type="text" /> -->
                <Select :placeholder=language.qingxuanze type="text" v-model="numpinzhong" clearable style="width: 200px">
                    <Option v-for="item in selectDatta" :value="item" :key="item" style="width: 150px;height: 40px;line-height: 30px;"></Option>
                </Select>
              </li>
              <li>
                <label>{{language.paihao}}</label>
                <!-- <input :placeholder=language.qingxuanze  v-model="handMoveSpecification" type="text" /> -->
                <Select :placeholder=language.qingxuanze type="text" v-model="numpaihao" clearable style="width: 200px">
                    <Option v-for="item in shopDatta" :value="item" :key="item" style="width: 150px;height: 40px;line-height: 30px;"></Option>
                </Select>
              </li>
              <li>
                <label style="width: 80px">{{language.kunbaohao}}</label>
                <!-- <input :placeholder=language.qingxuanze  v-model="kunbaohao" type="text" /> -->
                <Input :placeholder=language.qingxuanze type="text" v-model="kunbaohao" clearable style="width: 150px"></Input>
              </li>
              <li>
                <label>{{language.cangku}}</label>
                <!-- <input :placeholder=language.qingxuanze  v-model="handMoveWareHouse" type="text" /> -->
                <Select :placeholder=language.qingxuanze type="text" v-model="numcangku" clearable style="width: 200px">
                    <Option v-for="item in  wareDatta" :value="item" :key="item" style="width: 150px;height: 40px;line-height: 30px;"></Option>
                </Select>

              </li>
              <li>
                <label>{{language.hou}}</label>
                <!-- <input :placeholder=language.qingxuanze  v-model="handMoveHeight" type="text" /> -->
                <Input :placeholder=language.qingxuanze type="text" v-model="handMoveHeight" clearable style="width: 100px"></Input>

              </li>
              <li>
                <label>{{language.kuan}}</label>
                <!-- <input :placeholder=language.qingxuanze  v-model="handMoveWide" type="text" /> -->
                <Input :placeholder=language.qingxuanze type="text" v-model="handMoveWide" clearable style="width: 100px"></Input>
              </li>
              <li>
                <label>{{language.chang}}</label>
                <!-- <input :placeholder=language.qingxuanze  v-model="handMoveWidth" type="text" /> -->
                <Input :placeholder=language.qingxuanze type="text" v-model="handMoveWidth" clearable style="width: 100px"></Input>

              </li>
              <li>
                <label style="width: 80px">{{language.mujuanhao}}</label>
                <!-- <input :placeholder=language.qingxuanze  v-model="handMoveWidth" type="text" /> -->
                <Input :placeholder=language.qingxuanze type="text" v-model="mujuantiaojian" clearable style="width: 100px"></Input>

              </li>
              
            </ul>
            <p @click="showHandMove(2)">{{language.chayuanliao}}</p>
          </div>
          <div class="hand_move_search_material_table">
            <Table  :columns="columns3" :data="data3" border></Table>
            <div @click="handMoveDataThreeMore" class="hand_move_search_material_table_more" v-show="handMoveDataThree">{{language.jiazaigengduo}}</div>
            <div @click="handMoveDataThreeMore" class="hand_move_search_material_table_more" v-show="!handMoveDataThree">{{language.jiazaiwanbi}}</div>
          </div>
        </div>
      </div>
      <div v-show="handMoveSearchMaterial">
        <div class="hand_move_maintenance_products">
          <!-- <button @click='jiesuan'>111</button> -->
          <p>2.{{language.weihujiagongchengpin}}</p>
          <div class="hand_move_maintenance_products_tabs">
            <div class="hand_move_maintenance_products_news">
              <div class="hand_move_maintenance_products_table">
                <Table :columns="columns4" :data="data4" border></Table>
                <div class="hand_move_products_computed_table">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <!-- <div class="hand_move_remark">
            <Input v-model="handMoveRemark" type="textarea" :rows="4" :placeholder="请输入需要填写的备注信息"></Input>
        </div> -->
        <div class="hand_move_submit_add_car">
          <p>
            <!-- <span  @click="submitTemporaryAddCar">{{language.tijiaoshenqing}}</span> -->
            <button id="submitTemporaryAddCar" @click="submitTemporaryAddCar" :disabled="isDisabled">{{language.tijiaoshenqing}}</button>
            <!-- <span @click="submitTemporaryAddCar(2)">暂存</span> -->
          </p>
        </div>
      </div>
    </div>
  </div>


</template>
<style lang="scss" scoped>
  #submitTemporaryAddCar{
    display: inline-block;
    border-radius: 4px;
    width: 150px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color: #1d92be;
    z-index: 10000;
    border: aliceblue;
  }
  .customerName{
      text-align:center;
    }

    .bootBanner{
            overflow:hidden;
            min-width:100%;
            margin-top:50px;
            position: fixed;
            bottom:-5px;
            margin-top:30px;
            z-index: 10;
            overflow:hidden;
        }
        .bootBanner span span{
        float: right;
        width:120px;
        height:100px;
        line-height: 100px;
        border: 1px solid #ccc;
        text-align:center;
        background-color:#1d92be;
        cursor:pointer;
        font-size: 15px;
        margin-right: 5px;
        display: block;
        }
        /*.boo*/
        .bootBanner .ivu-icon{
            margin-right:5px;
            color: #ffffff;
            font-size: 20px;
        }
        .bootBanner .liang{
        background-color:#e5ebf2;
        display: block;
        /*width: %;*/
        height: 100px;
        margin-right:200px;
        /*position: fixed;*/
        /*bottom: -10px;*/
        /*margin-right: 20px;*/
        
        }
                .liang span{
        color: white;
        font-size:20px;
        /*display: block;*/
        /*display: block;*/
        }
    .serchlist select{
    width:180px;
    height: 40px;
    border-radius: 5px;
    border:1px solid #dddddd;

    }
  .serchlist .pz span{
    position: absolute;
    left: 10px;
    top:-15px;
    height: 20px;
}
.serchlist .chxz span{
    position: absolute;
    left: 10px;
    top:-15px;
    height: 20px;
}
.serchlist .kunbaos span{
    position: absolute;
    left: 10px;
    top:-15px;
    height: 20px;
}
.serchlist .pz,.ph,.hou,.kuan,.chang,.ck,.kunb,.muj,.chxz,.chanpinyuanliao,.kunbaos{
    position: relative;
    /*float: left;*/
    margin-left: 50px;
    margin-top: 20px;
    display: inline-block;
}
.serchlist .chanpinyuanliao span{
    position: absolute;
    left: 10px;
    top:-15px;
    height: 20px;
}
.serchlist .ph span{
    position: absolute;
    left: 10px;
    top:-15px;
    height: 20px;
}
/*.serchlist .hou span{
    position: absolute;
    left: 10px;
    top:-15px;
    height: 20px;
}*/
.serchlist .kuan span{
    position: absolute;
    left: 10px;
    top:-15px;
    height: 20px;
}
.serchlist .chang span{
    position: absolute;
    left: 10px;
    top:-15px;
    height: 20px;
}
.serchlist .ck span{
    position: absolute;
    left: 10px;
    top:-15px;
    height: 20px;
}
.serchlist .kunb span{
    position: absolute;
    left: 10px;
    top:-15px;
    height: 20px;
}
.serchlist .muj span{
    position: absolute;
    left: 10px;
    top:-15px;
    height: 20px;
}
    .chaxun,.chongzhi{
    width:120px;
    height: 40px;
    background-color:#1d92be;
    border-radius: 10px;
    text-align: center;
    line-height: 40px;
    color: #f5f5f5;
    margin-top: 40px;
    display: inline-block;
    margin-right: 350px;
}
.serchlist input{
        width:180px;
        height: 40px;
        /*margin-top:30px;*/
        text-align: center;
        border:1px solid #ccc;
        border-radius:5px;
    }
    .serchlist span{
        min-width:50px;
        height: 30px;
        line-height: 30px;
        display: inline-block;
        text-align: center;
        background-color: white;
    }
    .topBar{
    position: relative;
    }
.numlitter{
  margin-right: 20px;
}
.iptlis{
  position: relative;
}
.iptlis .ico{
  position: absolute;
  right: 288px;
  top:23px;
  z-index: 11;
}
/*            .chaxun,.chongzhi{
    width:120px;
    height: 40px;
    background-color:#1d92be;
    border-radius: 10px;
    text-align: center;
    line-height: 40px;
    color: #f5f5f5;
    margin-top: 50px;
}
*//*.serchlist .chaxun{
    margin:0 auto;
    margin-left: 500px;

}*/
.adddingdan{
    margin-bottom: 90px;
    overflow:none;

}
.adddingdan .daohang{
      margin-left: 20px;
      margin-top:10px;
    }
    .daohang{
    position: absolute;
    top:10px;
    left: 10px;
    z-index: 10;
    }
    .iptli{
        width:140px;
        border:none;
        height: 24px;
        position: absolute;
        right: 168px;
        top:18px;
        cursor: pointer;
        background-color: #eaeaea;
        padding-left:30px;
        /*box-shadow: 3px 6px 6px 2px #E6E3F5;*/
        text-align:left;
        border-radius: 3px;
        z-index: 10;
        /*border-shadow:3px 6px;*/
        /*position: relative;*/
    }
    .numEve{
        position: absolute;
        right: 61px;
        top:15px;
        line-height: 30px;
        background-color:#ffffff;
        height: 30px;
        width: 250px;
        text-align: right;
        color: #0066ff;
    }
    .iptc{
        height: 65px;
        /*border-bottom: 1px solid #dddddd;*/
        /*border-top: 1px solid #dddddd;*/
        position: relative;
        background:url(../assets/header.gif)repeat-x 0 0px;
        background-color: #cdd9e8;
        border-color: #8ba0bc;
    }

/*    .serchlist{
        position: absolute;
        width:100%;
        height: 250px;
        border-bottom:2px solid #ccc;
        background-color:white;
        z-index: 10;
        top:65px;
        /*left: 80px;*/

/*    .serchlist input{
        width:180px;
        height: 40px;
        margin-top:30px;
        text-align: center;
        border-radius:5px;
        border:1px solid #ccc;
        margin-left: 20px;

    }*/

/*    .serchlist span{
        width:80px;
        height: 20px;
        line-height: 30px;
        display: inline-block;
        text-align: center;
        background-color: white;
    }*/
/*    .serchlist div{
        position: relative;
        float:left;
        margin-left: 160px;
    }*/
    /*.pinzhongs{
        position: absolute;
        left: 10px;
        top:13px;
    }
    .paihaos{
        position: absolute;
        left: 10px;
        top:15px;
    }
        .hous{
        position: absolute;
        left: 10px;
        top:15px;
    }
        .kuans{
        position: absolute;
        left: 10px;
        top:15px;
    }
        .changs{
        position: absolute;
        left: 10px;
        top:15px;
    }
        .cangkus{
        position: absolute;
        left: 10px;
        top:15px;
    }
        .kunbaohaos{
        position: absolute;
        left: 10px;
        top:15px;
    }
        .mujuanhaos{
        position: absolute;
        left: 10px;
        top:15px;
    }*/














  .add_ding_dan_shen_qing_table{
    .ivu-table-wrapper{
      width:99% !important;
    }
  }
  .ivu-table-wrapper{
    /*border:none !important;*/
  }
  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  .add_ding_dan_jian_shu_liang{
    padding-left: 10px;
    font-size: 12px;
    text-align: center;
  }
  .add_ding_dan_shen_qing_list{
    text-align: center;
    .add_ding_dan_shen_qing_list_spes{
      color:#0000ff;
      margin-right: 5px;
    }
    .add_ding_dan_shen_qing_num{
      color:#0000ff;
      margin-right: 5px;
    }
  }
  .add_ding_dan_jian_tou{
    text-align: center;
    .ivu-icon{
      font-size: 30px;
      color: #0000ff;
    }
  }
  .add_ding_dan_shu_liang{
    width:100%;
    height:20px;
    line-height: 20px;
    margin:0 auto;
    text-align: center;
    .add_ding_dan_shu_liang_margin{
      margin-right: 10px;
    }
  }
  .add_ding_dan_p_top{
    width:100%;
    height:30px;
    line-height: 30px;
    display: flex;
    justify-content: space-between;
    .add_ding_dan_p_span_left{
      /*flex:1;*/
      padding-left: 10px;
      margin:0 auto;
      text-align: center;
      color:#0000ff;
      
    }
  }
  .more_text{
        color:#0000ff;
        display: inline-block;
        vertical-align: middle;
        /*width:120px;*/
        margin-left: 10px;
        /*overflow: hidden;*/
        /*text-overflow:ellipsis;*/

        /*white-space: nowrap;*/
      }
  .add_ding_dan_shen_qing_table tr{
    background-color: red;
  }
  /**.wait_submit_car .ivu-table-wrapper*/
  .closeShoping{
    font-size: 20px;
    font-weight: bold;
    /*line-height: 30px;*/
    height: 20px;
    margin-top: 5px;
  }
  .bgc{
    background-color:#B4CAE3 !important;
    opacity:.62;
    color:#333;
  }

  .ivu-table-body{
    overflow: inherit;
  }
  .class-a{
    background-color:pink;
  }
  .class-b{
    background-color:#cccccc;
  }
  .add_ding_dan_sq_car{
    /*height: 100px;*/
    position: fixed;
    min-width:89%;
            bottom:0px;
            left: 197px;
            display: block;
            margin-top:30px;
            /*z-index: -1;*/
    /*position: relative;*/
    /*bottom:-100px;*/
  }
  .add_dingdan_shenqing_car{
    height:100px;
    background-color: #e5ebf2
  }
  .ivu-tabs{
    overflow: inherit;
  }
  .hand_move_wei_hu_cheng_pin{
    width:100%;
    height:40px;
    line-height:40px;
    p{
      margin:0;
      padding:0;
      width:100%;
      height:40px;
      line-height:40px;
      span{
        display:inline-block;
        margin-left:10px;
      }
      .hand_move_wei_hu_cheng_pin_width{
        margin-left:50px;
      }
      .hand_move_wei_hu_cheng_pin_width_num{
        width:30px;
        height:30px;
        line-height:30px;
        color:red;
      }
      .hand_move_wei_hu_cheng_pin_add{
        cursor:pointer;
        margin-left:10px;
        width:70px;
        height:30px;
        line-height:30px;
        text-align:center;
        border-radius:4px;
        background-color:skyblue;
        color:#fff;
        &:hover{
        }
      }
      .hand_move_wei_hu_cheng_pin_true{
        cursor:pointer;
        margin-left:10px;
        width:70px;
        /*height:70px;*/
        text-align:center;
        border-radius:4px;
        line-height:30px;
        background-color:skyblue;
        color:#fff;
        &:hover{
        }
      }
    }
  }

  .hand_move_submit_car{
    z-index:900 !important;
    overflow-y: scroll;
    overflow-x: hidden;
    width:100%;
    padding-right:120px;
    z-index:10;
    background-color: #fff;
    position:fixed;
    top:0px;
    right:0px;
    left:125px;
    bottom:0px;
    .hand_move_remark{
      width:40%;
      margin:20px 0 0 100px;
    }
    .hand_move_title_car{
      width:1200px;
      margin-left:100px;
      text-align:center;
      height:30px;
      p{
        width:160px;
        text-align:center;
        margin-left:520px;
        height:30px;
        line-height:30px;
        position:relative;
        &:before {
          content:"";
          width:520px;
          height:10px;
          border-top:1px solid #333;
          position:absolute;
          top:14px;
          right:160px;
        }
        &:after {
          content:"";
          width:500px;
          height:10px;
          border-top:1px solid #333;
          position:absolute;
          top:14px;
          left:160px;
        }

      }
    }
    .hand_move_submit_car_title{
      background-color:#fff;
      height:60px;
      line-height:60px;
      z-index: 111;
      position:relative;
      h3{
        width:1200px;
        margin:0;
        margin-left:100px;
        text-align:center;
        height:60px;
        line-height:60px;
      }
      p{
        cursor:pointer;
        span{
          width:20px;
          height:20px;
          margin-right:-10px;
          display:inline-block;
        }
        background-color:#1d92be;
        width:100px;
        height:60px;
        color:#fff;
        line-height:60px;
        padding-left:10px;
        position:absolute;
        left:0px;
        top:0;
      }
    }
    .hand_move_submit_add_car{
      background-color:#fff;
      height:70px;
      position:relative;
      p{
        cursor:pointer;
        width:400px;
        height:50px;
        line-height:50px;
        text-align:center;
        margin:10px;
        position:absolute;
        left:50%;
        top:5px;
        transform:translateX(-50%);
        color:#fff;
        span{
          margin-right:20px;
          display:inline-block;
          border-radius:4px;
          width:150px;
          height:50px;
          line-height:50px;
          text-align:center;
          background-color:#1d92be;
          z-index: 10000;
          margin-bottom: 20px;
        }
      }
    }
    .hand_move_maintenance_products{
      margin:20px 0 0 80px;
      padding:15px;
      border:1px solid #eee;
      .hand_move_maintenance_products_tabs{
        width:100%;
        /*height: 400px;*/
        overflow: visible !important;
      }
    }
    .hand_move_search_material{
      margin-left:80px;
      padding:15px;
      border:1px solid #eee;
      .hand_move_search_material_news{
        .hand_move_search_material_condition{
          display: inline-block;
          height:70px;
          ul{
            /*float:left;*/
            height:100px;
            line-height:60px;
            list-style-type:none;
            width:90%;
            li{
              height:60px;
              line-height:50px;
              float:left;
              margin:0 25px 0 5px;
              position:relative;
              label{
                position:absolute;
                left:5px;
                top:-3px;
                text-align:center;
                width:50px;
                height:20px;
                line-height:20px;
                font-size:14px;
                background-color:#fff;
                font-weight: 100;
                z-index: 2;
              }
              input{
                width:70px;
                height:35px;
                border:1px solid #a9a9a9;
              }
            }
          }
          p{
            cursor:pointer;
            color:#fff;
            width:100px;
            height:40px;
            line-height:40px;
            text-align:center;
            background-color: #1d92be;
            border-radius:4px;
            /*float:right;*/
            position: absolute;
            right: 150px;
            top:140px;
            /*margin-top: 0px;*/
            margin:0px 0 0 40px;
            /*margin-bottom: 50px;*/
            &:hover{
            }
          }
        }
        .hand_move_search_material_table{
          margin-top: 50px;
          .hand_move_search_material_table_more{
            width:150px;
            height:30px;
            line-height: 30px;
            margin:10px auto;
            text-align: center;
            cursor: pointer;
            &:hover{
            }
          }
          /*width:95%;*/
        }
      }
    }

  }
  .submit_add_car{
    border:1px solid #eee;
    padding:10px;
    background-color:#fff;
    height:90px;
    p{
      cursor:pointer;
      width:150px;
      height:50px;
      line-height:50px;
      text-align:center;
      margin:10px;
      float:right;
      border-radius:4px;
      color:#fff;
      background-color:#169bd5;
      &:hover{
      }
    }
  }
  .adddingdan_change_height{
    min-height:520px;
    margin-bottom:100px;
  }
  .wait_submit_car{
    width:88%;
    z-index:9;
    position:fixed;
    right:0px;
    bottom:100px;
    .wait_submit_car_title{
      background-color:white;
      border:1px solid #ccc;
      height:50px;
      line-height:40px;
      position:relative;
      h3{
        width:200px;
        height:40px;
        line-height:10px;
        font-size: 20px;
        margin-left:10px;
      }

      p{
        cursor:pointer;
        span{
          width:20px;
          height:20px;
          display:inline-block;

        }
        /*width:60px;*/
        height:40px;
        position:absolute;
        right:30px;
        top:5px;
      }
    }
  }
  .closeSubmitCar .ivu-icon{
    font-size: 100px;
  }
  /*.adddingdan{height:100%;}*/
  .add_ding_dan_sq_car{
    /*width:100%;*/
    height:100px;
    background-color:#e5ebf2;
    /*position:absolute;*/
    /*bottom:0;*/
    /*right:0;*/
    .add_dingdan_shenqing_car{
      background-color:#1d92be;
      margin-left:3px;
      width:100px;
      height:100%;
      float:right;
      position: relative;
      span{
        display:inline-block;
        width:20px;
        height:20px;
        margin-left:40px;
      }
      p{
        color:#fff;
        text-align:center;
        height:30px;
        line-height:80px;
        cursor:pointer;
      }
      .ivu-icon{
        color:white;
        font-size: 30px;
        line-height: 30px;
        position: absolute;
        top:25px;
        left:40px;
      }
    }
  }
  .add_ding_dan_shen_qing_table_more_data{
    cursor:pointer;
    text-align:center;
    height:30px;
    line-height:30px;
    margin-top: 20px;


    &:hover{
    }
  }
  .add_ding_dan_sq{
    /*//position:relative;*/
    border:1px solid #eee;
    margin-bottom:100px;
    display:flex;
    margin:5px;
    .add_ding_dan_shen_qing_table{
      min-width:900px;
      /*max-width: 1200px;*/
      width:100%;
      margin-left:20px;
    }
    .add_ding_dan_shen_qing{
      cursor:pointer;
      flex:0 0 20%;
      min-height: 83px;
      background-color:#e9eaec;
      border: 1px solid #dedbdb;
      /*display:flex;*/
      height: 100%;
      width: 300px;
      /*justify-content: space-between;*/
      .add_ding_dan_shen_qing_left{
        margin-top:10px;
        width:100px;
        min-height:70px;
        //line-height:70px;
        p{
          /*height:34px;*/
          /*line-height:34px;*/
          padding-left:15px;
          margin:0;
          .add_ding_dan_cate{
            margin-right:10px;
            margin-top:-50px;
            /*display: inline-block;*/
          }
        }
        div{
          margin-left: 100px;
          .ivu-icon{
            font-size: 30px;
            color: blue;
          }
        }
      }
      .add_ding_dan_shen_qing_right{
        width:100px;
        p{
          height:20px;
          line-height:20px;
          margin:10px 0 0 0;
          margin-left:-10px;
        }
      }
     
    }

  }
  /*    .backColor:{
          background-color:#1980a6;
      }*/
</style>
<script>
  import {mapGetters,mapActions} from 'vuex'
  import addDingDanComplate from './addDingDanComplate.vue';
  import axios from 'axios'
  import config from 'config/apiConfig'
  import language from 'api/language'
  // import numberList from '../components/numberlist'
  // import addDingdanexpand from './addDingdanexpand.vue'
  export default {
    data () {
      return {
        
        isDisabled: false,
        language:{},
        // ifDengFenDisabled:false,
        handMoveDataThreetotalPageCount:'',
        handMoveDataThree:false,
        bgc:false,
        handMoveCategoryCode:'',
        handMoveSpecification:'',
        handMoveHeight:'',
        handMoveWide:'',
        handMoveWidth:'',
        mujuantiaojian:'',
        // handMoveWareHouse:'',
        kunbaohao:'',
        // addMoreData:true,
        numpinzhong:'',
        numpaihao:'',
        cpyl:'',

        numhou:'',
        numchang:'',
        numkuan:'',
        numcangku:'',
        // numpinzhong:'',
        // nummujuanhao:'',
        numnum:'',
        // orderNum:'',
        // packNumK:'',
        cunhuo:'',
        numpaihaos:'',
        datanows:'',

        // prodCode:'',
        raval:false ,
        // currentTemplate:'',
        // handMoveRemoveNum:'',
        // handMoveRemark:'',
        showSubmitCarNews:true,
        moreNumber:'',
        handMove:false,
        submitCar:false,
        handMoveSearchMaterial:false,
        // handMoveSearchMaterialWHCP:false,
        addDingDanShenQingTable:'false',
        nameTab:'addpostOne',
        selectDatta:[],
        shopDatta:[],
        wareDatta:[],
        // dataNewpro:'',
        exposedNum:'',
        moredata:true,
        chengpinnum:[],
        p:'',
        l:'',
        dengfenIf:false,
        customer:[],
        // customers:[],
        flagdeng:false,
        jiagongWeight:'',
        jiagongzhongliang:'',
        // templateList:[{
        //     "templateCode": "temp001",
        //     "categoryCode": "GI",
        //     "specification": "1.2*1295*C",
        //     "shopsign": "CR340LA",
        //     "productList": [{
        //         "spes": "1.6*100*C",
        //         "prodQty": "6",
        //         "prodWeight": "200kg"
        //     },{
        //         "spes": "1.6*200*C",
        //         "prodQty": "2",
        //         "prodWeight": "300kg"
        //     },{
        //         "spes": "1.6*200*C",
        //         "prodQty": "1",
        //         "prodWeight": "200kg"
        //     }]
        // }, {
        //     "templateCode": "temp002",
        //     "categoryCode": "CR",
        //     "specification": "1.5*690*C",
        //     "shopsign": "CR340LA",
        //     "productList": [{
        //         "spes": "1.5*100*C",
        //         "prodQty": "3",
        //         "prodWeight": null
        //     }, {
        //         "spes": "1.5*50",
        //         "prodQty": "3",
        //         "prodWeight": null
        //     }, {
        //         "spes": "1.5*200",
        //         "prodQty": "1",
        //         "prodWeight": null
        //     }]
        // }],
        templateList:[],
        queryClearinguser:[],
        settlementCurrency:[],
        deliveryMethod:[],
        // selectVal:'',
        columns1: [
          {
            title: language.shouhuokehu,
            key: 'customerName',
            align: 'center',
            minWidth: 118,
          },
          {
            title: language.cangku,
            minWidth: 40,
            key: 'warehouseName',
            align: 'center'
          },
          {
            title: language.kunbaohao,
            key: 'serialCode',
            align: 'center',
            minWidth: 85,
          },
          {
            title: language.pinzhong,
            key: 'categoryCode',
            align: 'center',
            minWidth: 40,
          },
          {
            title: language.paihao,
            key: 'shopsign',
            align: 'center',
            minWidth: 65,
          },
          {
            title: language.guige,
            key: 'specification',
            align: 'center',
            minWidth: 80,
          },
          {
            title: language.zhongliang,
            key: 'primaryQty',
            align: 'center',
            minWidth: 50,
          },
          {
            title: language.neiwaiban,
            key: 'exposedName',
            align: 'center',
            minWidth: 75,
          },
          {
              title: language.duxinceng,
              key: 'extCol12',
              align:'center',
              minWidth:90
          },
          {
            title: language.juanjing,
            key: 'rollPath',
            minWidth: 40,
            align: 'center'
          },
          {
            title: language.rukuriqi,
            key: 'stockInDate',
            align: 'center',
            minWidth: 75,
          },
          {
            title: language.mujuanhao,
            minWidth: 85,
            key: 'reelNo',
            align: 'center',
            // minWidth: 100,
          },
          {
            title: language.mujuanguige,
            key: 'rawPieceSpecdesc',
            align: 'center',
            minWidth: 80,
          },
          {
            title: language.mujuanzhongliang,
            // minWidth: 60,
            key: 'rawPrimaryQty',
            align: 'center',
            minWidth: 65,
          },
          {
            title: language.jiagongzhongliang,
            key: 'processingWeight',
            align: 'center',
            minWidth: 70,
            render: (h, params) => {
              // this.data1[params.index].processingWeight = params.row.primaryQty;
              return h('div', [
                h('Input', {
                  attrs:{
                      id:"processingWeight"
                  },
                  props: {
                    number:true,
                    // required:true,
                    // pattern:'/^[a-z0-9]+$/',
                    // message:'请输入数字',
                    // trigger:'change'
                    value:params.row.rawPrimaryQty
                    // value:params.row.processingWeight
                  },
                  on:{
                    'on-blur':(event) => {
                      this.jiagongzhongliang=event.target.value;
                      console.log(this.jiagongzhongliang);
                      //this.addCarDataOne(params,event)
                      //  vm.data[params.index].value = event.target.value;
                    }
                  },
                })
              ]);
            }
          },
          // {
          //     title: 'order no',
          //     key: 'orderNo',
          //     align: 'center',
          //     minWidth: 100,
          // },
          {
            title: language.caozuo,
            key: 'caozuo',
            minWidth: 60,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  style:{
                    border:'none',
                    backgroundColor:'#fff'
                  },
                  on:{
                    click: (e)=>{
                    this.addCars(params)
                    }
                  }
                },[
                  h('Icon', {
                    props: {
                      type: 'ios-cart'
                    }
                  })

                ])
              ]);
            }
          }
        ],
        data1: [
          // {
          //   // applyId: "applyId",
          //   applyCode: "applyCode",
          //   customerId: null,
          //   customerName: "李四",
          //   weight: "100",
          //   applyTime: "2018-04-28 00:00:00",
          //   status: "10",
          //   remarks: "新增",
          //   processQuerySubBeanLists: null
          // },
          // {
          //   applyId: "1003",
          //   applyCode: " SA18000026",
          //   customerId: null,
          //   customerName: "李四",
          //   weight: "100",
          //   applyTime: "2018-04-28 00:00:00",
          //   status: "10",
          //   remarks: "新增",
          //   processQuerySubBeanLists: null
          // },
          // {
          //   applyId: "1003",
          //   applyCode: " SA18000026",
          //   customerId: null,
          //   customerName: "李四",
          //   weight: "100",
          //   applyTime: "2018-04-28 00:00:00",
          //   status: "10",
          //   remarks: "新增",
          //   processQuerySubBeanLists: null
          // },
          // {
          //   applyId: "1003",
          //   applyCode: " SA18000026",
          //   customerId: null,
          //   customerName: "李四",
          //   weight: "100",
          //   applyTime: "2018-04-28 00:00:00",
          //   status: "10",
          //   remarks: "新增",
          //   processQuerySubBeanLists: null
          // }
        ],
        columns2: [
          {
            title: language.cangku,
            key: 'warehouseName',
            minWidth: 80,
            // width:50,
            align: 'center'
          },
          {
            title: language.kunbaohao,
            key: 'serialCode',
            minWidth: 75,
            align: 'center'
          },
          {
            title: language.pinzhong,
            minWidth: 40,
            key: 'categoryCode',
            align: 'center'
          },
          {
            title: language.paihao,
            minWidth: 70,
            key: 'shopsign',
            align: 'center'
          },
          {
            title: language.guige,
            minWidth: 75,
            key: 'specification',
            align: 'center'
          },
          {
            title: language.zhongliang,
            minWidth: 40,
            key: 'primaryQty',
            align: 'center'
          },
          {
            title: language.mujuanhao,
            key: 'reelNo',
            minWidth: 85,
            align: 'center'
          },
          {
            title: language.mujuanguige,
            key: 'specification',
            minWidth: 75,
            align: 'center'
          },
          {
            title: language.mujuanzhongliang,
            key: 'shopsign',
            minWidth: 75,
            align: 'center'
          },
          {
            title: language.jiagongzhongliang,
            minWidth: 70,
            key: 'processingWeight',
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Input', {
                  props: {
                    number:true,
                    value:params.row.processingWeight
                    //value:this.datas[params.index].processingWeight
                  },
                  on:{
                    'on-blur':(event) => {
                      this.addCarDataTwo(params,event.target.value)
                      //vm.data[params.index].value = event.target.value;
                    }
                  },
                  // style:{
                  //   placeholder:
                  // }
                })
              ]);
            }
          },
          {
            title: language.dengfen,
            key: 'ifDengFen',
            width: 50,
            minWidth:50,
            align: 'center',
            className:'ifDengFen',
            render: (h, params) => {
              return h('div', [
                h('Checkbox', {
                  props:{
                    value:params.row.ifDengFen,
                    disabled:params.row.dengfenIf,
                  },
                  on:{
                    'on-change':(event) => {
                      this.changeDengFen(params,event)
                      // this.addCar(params,event.target.value)
                      //vm.data[params.index].value = event.target.value;
                    }
                  },
                  style:{
                        border:'2px solid red',
                        padding:'5px'
                      }
                })
              ]);
            }
          },
          {
            title: language.jiaohuoqi,
            key: 'deliveryDate',
            align: 'center',
            minWidth:210,
            width:210,
            className:'deliveryDate',
            render:(h,params) => {
              //arrow-up-a
              //console.log(params.row._index);
              if(params.row._index==0){
                return h('div',[
                h('DatePicker', {
                props:{
                  type:"date",
                  value: params.row.deliveryDate
                },
                style:{
                   paddingLeft:'5px',
                   width:'150px'
                  },
                on:{
                  'on-change': (val) => {
                    this.dataChange(params,val)
                  }
                }
              }),
              h('Button', {
                    props: {
                      size: 'small'
                    },
                    style:{
                      border:'none',
                      backgroundColor:'#fff',
                      marginLeft:'5px'
                    },
                    attrs:{
                      title:'일괄적용'
                    },
                    on:{
                      click: ()=>{
                        this.againDeliveryDate(params)
                      }
                    }
                  },[
                    h('Icon', {
                      props: {
                        type: 'arrow-down-a'
                      },
                      style:{
                        color:"#0066ff",
                        fontSize:"30px"
                      }
                    })
                  ])
                ])
              }else{
                 return h('div',[
                h('DatePicker', {
                props:{
                  type:"date",
                  value: params.row.deliveryDate
                },
                style:{
                  paddingLeft:'5px',
                  width:'150px'
                  },
                on:{
                  'on-change': (val) => {
                    this.dataChange(params,val)
                  }
                }
              })]
              )
              }
            }
          },
          {
            title: language.chengpinguigezhongliangshuliang,
            key: 'processQueryProductList',
            align: 'center',
            minWidth:170,
            render: (h, params) => {
              if(params.row.processQueryProductList.length>0){
                const templatenews = params.row.processQueryProductList.map((item)=>{
                  const  spes = item.spes == null ? '0': item.spes;
                  const  prodWeight = item.prodWeight == null ? ' 0 ': item.prodWeight +'kg';
                  const  prodQty = item.prodQty == null ? ' 0 ': '  '+item.prodQty +language.tiao2;
                  return     h('p', [
                    h('span', {
                      style:{
                        color:'skyblue'
                      }
                    },spes),
                    h('span', {
                      style:{
                        color:'skyblue',
                        marginLeft:'2px'
                      }
                    },prodWeight),
                    h('span', {
                      style:{
                        color:'skyblue',
                        marginLeft:'2px'
                      }
                    },prodQty),
                  ])

                })
                return h('div',templatenews)

              }
            }
          },
          {
            title: language.mobanmingcheng,
            key: 'templateName',
            align: 'center',
            minWidth: 70,
          },
          // {
          //   title: '模板编号',
          //   key: 'templateCode',
          //   align: 'center',
          //   minWidth: 70,
          // },
          {
            title: language.caozuo,
            key: 'caozuo',
            align: 'center',
            minWidth: 50,
            // width: 50,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  style:{
                    border:'none',
                    backgroundColor:'#fff'
                  },
                  on:{
                    click: ()=>{
                      this.removeCar(params)
                    }
                  }
                },[
                  h('Icon', {
                    props: {
                      type: 'reply-all'
                    },
                    style:{
                      color:"#0066ff",
                      fontSize:"30px"
                    }
                  })

                ])
              ]);
            }
          }
        ],
        data2:[],
        data3:[],
        data4:[],
        // data5:[{}],
        columns3: [
          {
            title: language.shouhuokehu,
            key: 'customerName',
            align: 'center',
            width: 70,
          },
          {
            title: language.cangku,
            key: 'warehouseName',
            align: 'center',
          },
          {
            title: language.kunbaohao,
            key: 'serialCode',
            align: 'center',
            width: 110,
          },
          {
            title: language.pinzhong,
            key: 'categoryCode',
            align: 'center',
          },
          {
            title: language.paihao,
            key: 'shopsign',
            align: 'center',
            width: 100,
          },
          {
            title: language.guige,
            key: 'specification',
            align: 'center'
          },
          {
            title: language.zhongliang,
            key: 'primaryQty',
            align: 'center'
          },
          {
            title: language.neiwaiban,
            key: 'exposedName',
            align: 'center',
            width: 90,
          },
          {
            title: language.duxinceng,
            key: 'extCol12',
            align:'center',
            width:90
          },
          {
            title: language.rukuriqi,
            key: 'stockInDate',
            align: 'center',
            width: 100,
          },
          {
            title: language.mujuanhao,
            key: 'reelNo',
            align: 'center'
          },
          {
            title: language.mujuanguige,
            key: 'rawPieceSpecdesc',
            align: 'center'
          },
          {
            title: language.mujuanzhongliang,
            key: 'rawPrimaryQty',
            align: 'center'
          },

          {
            title: language.caozuo,
            key: 'caozuo',
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  style:{
                    border:'none',
                    backgroundColor:'#fff'
                  },
                  on:{
                    click: ()=>{
                      this.addHandMoveCars(params)
                    }
                  }
                },[
                  h('Icon', {
                    props: {
                      type: 'ios-cart'
                    }
                  })

                ])
              ]);
            }
          }
        ],
        columns4: [
          {
            title: language.shanchu,
            key: 'caozuo',
            align: 'center',
            width: 45,
            render: (h, params) => {
              return h('div',
                [
                  h('p',{
                    style:{
                      marginTop:'5px',
                      cursor:'pointer',
                      color:'skyblue'
                    },
                    on:{
                      click: ()=>{
                        this.removrHandMove(params)
                      }
                    }
                  },[
                    h('Icon', {
                      style:{
                        color:'skyblue',
                        fontSize:'25px',
                        cursor:'pointer'
                      },
                      props:{
                        type:'close-circled'
                      },
                    })
                  ])

                ])
            }
          },
          {
            title: language.caozuo,
            key: 'caozuo',
            align: 'center',
            width: 45,
            type: 'expand',
            render: (h, params) => {
              // alert(111)
              // console.log(data4)
              // console.log(that.dataNews)
              let that = this;
              let $ref = params;
              return h('div',[
                h(addDingDanComplate, {
                  // script
                  props: {
                    data4: that.data4[$ref.index],
                  },
                  on:{
                    'on-change':(event) => {
                      // console.log(event)
                      that.handMoveWeiHuChengPinTrue(params,event)
                      // console.log(data4)
                      // this.handMoveChangeDengFen(params,event)
                    }
                  }
                })
              ])
            }
          },
          {
            title: language.shouhuokehu,
            key: 'customerName',
            align: 'center',
            width: 80,
          },
          {
            title: language.cangku,
            key: 'warehouseName',
            align: 'center',
            width: 50,
          },
          {
            title: language.kunbaohao,
            key: 'serialCode',
            align: 'center',
            width: 110,
          },
          {
            title: language.pinzhong,
            key: 'categoryCode',
            align: 'center',
            width: 54,
          },
          {
            title: language.paihao,
            key: 'shopsign',
            align: 'center',
            width: 100,
          },
          {
            title: language.guige,
            key: 'specification',
            align: 'center',
            width: 90,
          },
          {
            title: language.zhongliang,
            key: 'primaryQty',
            align: 'center',
            width: 54,
          },

          {
            title: language.neiwaiban,
            key: 'exposedName',
            align: 'center',
            width: 90,
          },
          {
            title: language.rukuriqi,
            key: 'stockInDate',
            align: 'center',
            width: 80,
          },
          {
            title: language.mujuanhao,
            key: 'reelNo',
            align: 'center',
            width: 80,
          },
          {
            title: language.mujuanguige,
            key: 'rawPieceSpecdesc',
            align: 'center',
            width: 80,
          },
          {
            title: language.mujuanzhongliang,
            key: 'rawPrimaryQty',
            align: 'center',
            width: 80,
          },
          {
            title: language.jiagongzhongliang,
            width: 85,
            key: 'processingWeight',
            align: 'center',
            render: (h, params) => {
              // console.log(params)
              let that = this;
              return h('div', [
                h('Input', {
                  props: {
                    number:true,
                     value:that.data4[params.index].processingWeight
//                    value:params.row.processingWeight
                  },
                  on:{
                    'on-blur':(event) => {
                      that.shoutian(params,event.target.value)
                    }
                  },
                })
              ]);
            }
          },
          {
            title: language.dengfen,
            key: 'ifDengFen',
            align: 'center',
            width: 64,
            align: 'center',
            className:'ifDengFen',
            render: (h, params) => {
              let that = this;
              return h('div', [
                h('Checkbox', {
                  props:{
                    value:params.row.ifDengFen,
                    disabled:params.row.ifDengFenDisabled,
                  },
                  on:{
                    'on-change':(event) => {
                      this.handMoveChangeDengFen(params,event)
                    }
                  },
                  style:{
                      border:'2px solid red',
                      padding:'5px'
                    }
                })
              ]);
            }
          },
          {
            title: language.jiesuanyonghu,
            key: 'settlementUser',
            align: 'center',
            width: 150,

            render: (h, params) => {
              let that = this;
              // that.jiesuan()
              let options =
                that.queryClearinguser.map(function(type){
                  return h('Option', {
                    props: {label: type.label == null?'':type.label,value: type.value == null?'':type.value},
                    style:{
                      width:'110px',
                      overflow:'hidden',
                    },
                    attrs: {title: type.label}
                  }, type.label);
                });
                      // console.log(11)
                      // console.log(props)

              return h('Select', {
                  props:{
                    filterable:true,
                    labelInValue:true,
                   // value: that.queryClearinguser[0].value,
                    value: that.data4[params.index].settlementUser,
                  },
                  // style:{
                  //     overflow:hidden
                  // },
                  on: {
                    'on-change':(value) => {
                      that.data4[params.index].settlementUser = value.value;
                      that.data4[params.index].settlementUserName = value.label;

                    }
                  },
                },
                [options
                ]
              );
            },
          },
          {
            title: language.jiesuanfangshi,
            key: 'settlementCurrency',
            align: 'center',
            width: 120,
            render: (h, params) => {
              let that = this;
              let options =
                that.settlementCurrency.map(function(type){
                  return h('Option', {
                    props: {label: type.label == null?'':type.label,value: type.value == null?'':type.value},
                    style:{
                      width:'100px',
                      overflow:'hidden',
                    },
                    attrs: {title: type.label}
                  }, type.label);
                });
              return h('Select', {
                  props:{
                    filterable:true,
                    labelInValue:true,
                   value: that.settlementCurrency[0].value,
                     value: that.data4[params.index].settlementCurrency,
                  },
                  on: {
                    'on-change':(value) => {
                      // console.log(value)
                      that.data4[params.index].settlementCurrency = value.value;
                      that.data4[params.index].settlementCurrencyName = value.label;
                    }
                  },
                },
                [options
                ]
              );
            },
          },
          {
            title: language.jiaohuoqi,
            key: 'deliveryDate',
            align: 'center',
            width: 150,
            render:(h,params) => {
                let that = this;
              return h('DatePicker',{

                props:{
                  type:"date",

                  value: that.data4[params.index].deliveryDate,
                  // console.log(value),
                },
                showWeekNumbers:true,
                on:{
                  'on-change': (val) => {
                    this.jiaohuoqi(params,val)
                  }
                },
              })
            }
          },
          {
            title: language.jiaohuofangshi,
            key: 'deliveryMethod',
            align: 'center',
            width: 120,
            render: (h, params) => {
              let that = this;
              let options =
                that.deliveryMethod.map(function(type){
                  return h('Option', {
                    props: {label: type.label == null?'':type.label,value: type.value == null?'':type.value},
                    style:{
                      width:'100px',
                      overflow:'hidden',
                    },
                    attrs: {title: type.label}
                  }, type.label);
                });
              // console.log(that)
              return h('Select', {
                  props:{
                    filterable:true,
                    labelInValue:true,
                    value: that.data4[params.index].deliveryMethod,
//                    value: that.deliveryMethod[0].value,
                  },
                  on: {
                    'on-change':(value) => {
                      that.data4[params.index].deliveryMethod = value.value;
                      that.data4[params.index].deliveryMethodName = value.label;

                    }
                  },
                },
                [options
                ]
              );
            },
          },

          {
            title: language.chengpinxinxi,
            key: 'processQueryProductList',
            width: 60,
            align: 'center',
            render: (h, params) => {
              let that = this
              if(that.data4[params.index].processQueryProductList != null && params.row.processQueryProductList.length>0){
                // const templatenews = that.data4[params.index].processQueryProductList.map((item)=>{
                //     const  spes = item.spes == null ? '': item.spes;
                //     const  prodWeight = item.prodWeight == null ? '': item.prodWeight +'kg';
                //     return     h('p',[
                //             h('span', {
                //                 style:{
                //                     color:'skyblue'
                //                 }
                //             },spes),
                //             h('span', {
                //                 style:{
                //                     color:'skyblue',
                //                     marginLeft:'2px'
                //                 }
                //             },prodWeight),
                //         ])

                // })
                return h('div',{style:{color:'skyblue'}},params.row.processQueryProductList.length)
              }else{
                return h('div','')
              }
            }
          },
          {
            title: language.beizhu,
            key: 'remarks',
            align: 'center',
            width: 180,
            render: (h, params) => {
              let that = this;
              return h('Input',{
                style:{
                  width:"160px",
                  clearable:true,
                },
                props: {
                  type:"textarea",
                  value:params.row.remarks
                },
                on:{
                  'on-blur':(event) => {
                    that.data4[params.index].remarks = event.target.value;
                  }
                },
              })

            }
          },
        ],

      }
    },
    filters:{
      numValue(item){
        let allNum = item.specification.split('*')[1];
        let allNumText = item.specification.split('*')[2];
        let childNum = 0;
        if(item.productList !=null &&item.productList.length>0){
          for(let i = 0; i<item.productList.length;i++){
        // console.log(item.productList[i])

            if(item.productList[i].spes.split('*')[2] != allNumText){
              return 'loss   0 mm';
            }
            childNum += parseInt(item.productList[i].spes.split('*')[1]*item.productList[i].firstNumbers);
          }
        }
        let newNum = parseInt(allNum) - childNum;
        if(newNum <= 0 ){
          return 'loss   0 mm';
        }
        return 'loss   '+newNum+'mm'
      }
    },
    // computed: {
    //     ...mapGetters({
    //         dataNewsInfor: 'dataNewsInfor',
    //         residueWidth: 'residueWidth',
    //     })
    // },
    methods: {
      ...mapActions({
        showNameTabs: 'showNameTabs',
        // processingWeight:'processingWeight'
      }),
            // 结算用户
      jiesuan(){
        let that = this;
        // this.data4[indexs.index].settlementUser = b;
        axios.post(config.queryClearinguser,{}).then(function(response){
          if(response.data.resultCode  == 1){
            // console.log(response)

            let activeValues = response.data.resultData;
            let arrNews= [];
            for(let i =0 ;i <activeValues.length ;i++){
              let activeName = {
                value:activeValues[i].tuTradeUnitId,
                label:activeValues[i].tuTradeUnitName,
                // code:activeValues[i].tuTradeUnitCode,
                // code:
              }
              // console.log(activeName)
              arrNews.push(activeName)
            }
            that.queryClearinguser = arrNews;
            // console.log(that.queryClearinguser)
          }
        })
      },
      jiesuans(){
                let that = this;
                // this.subplanNumJihua[indexs.index].settlementUser = b;
                axios.post(config.queryClearinguser,{}).then(function(response){
                    if(response.data.resultCode  == 1){
                        // console.log(response)

                        let resultData=response.data.resultData
                  for(var i=0;i<resultData.length;i++){
                      if(resultData[i].tuTradeUnitName!=null){
                          that.customer.push(resultData[i])
                          // that.customers.push(resultData[i].tuTradeUnitId)
                          // that.customer.push(resultData[i].tuTradeUnitId)
                      }
                      // console.log(that.customer)
                      // console.log(resultData[i].categoryCode)
                      // console.log(that.selectDatta)
                  }
                        // that.queryClearinguser = arrNews;
                    }
                })
        },
        removeSubmitAddCar(){
            let that = this
            let paramsData=new FormData();
            let numberser=new Array()
            if(that.data2.length>0){
                for(var i=0;i<that.data2.length;i++){
                // console.log(x[0].value.group[i].serialCode)
                numberser.push(that.data2[i].serialCode)
            }
            // console.log(numberser)
            paramsData.append("serialCode",numberser.toString());
            // console.log(paramsData)

        // let paramsData = new FormData();

        //          paramsData= {
        //         shopCartTemplateList:that.data2
        //         }
        //   // console.log(paramsData)
        // // let that = this;
        // paramsData.append("serialCode", indexs.row.serialCode);
        // console.log(paramsData)
        const instance = axios.create({
        withCredentials: true
        })
        instance.post(config.deleteCart,paramsData).then(function(response){
          // console.log(response)
          if(response.data.resultCode  == '1'){
            that.showSubmitCar()
            that.$Message.info(language.gouwucheyiqingkong)
            // that.data2.splice(indexs.index,1)
          }
          //that.data2 = response.data.resultData;
        })
          .catch(function (error) {
            console.log(error)
          });
      }
            
        },
        warehouseNameDrop(){
            let that = this
            axios.post(config.warehouseNameDrop,{}).then(function(response){
               let resultDatas=response.data.resultData
                for(var i=0;i<resultDatas.length;i++){
                    if(resultDatas[i].warehouseName!=null){
                    that.wareDatta.push(resultDatas[i].warehouseName)

                    }
                    // console.log(resultData[i].categoryCode)
                    // console.log(response)
                }
            })
        },
        shopsignDrop(){
          let that = this;
          axios.post(config.shopsignDrop,{}).then(function(response){
              // console.log(1)
              // console.log(response.data.resultData)
              let resultDatas=response.data.resultData
              for(var i=0;i<resultDatas.length;i++){
                  if(resultDatas[i].shopsign!=null){
                  that.shopDatta.push(resultDatas[i].shopsign)

                  }
                  // console.log(resultData[i].categoryCode)
                  // console.log(that.shopDatta)
              }
          })
        },
      selectType(){
          let that = this;
          axios.post(config.categoryCodeDrop,{}).then(function(response){
              // console.log(response.data.resultData)
              let resultData=response.data.resultData
              for(var i=0;i<resultData.length;i++){
                  if(resultData[i].categoryCode!=null){
                      that.selectDatta.push(resultData[i].categoryCode)
                  }
                  // console.log(resultData[i].categoryCode)
                  // console.log(that.selectDatta)
              }
          })
      },
      //购物车对应的交货日期数据
      dataChange(indexs,val){
        this.data2[indexs.index].deliveryDate = val;
      },


      //手填订单购物车对应的等分数据
      handMoveChangeDengFen(indexs,a){
        // console.log(a);
        //indexs.row.ifDengFen=a
//        this.data4[indexs.index].ifDengFen = a;
        this.$set(this.data4[indexs.index],"ifDengFen",a);
        // this.$setAttribute(this.data4[indexs.index].ifDengFen,"type",disabled);
        // console.log(a)
        // console.log(disabled)
        // console.log()
        // console.log(this.data4)
        // console.log(this.data4)
      },

      // 结算方式
      fangshi(){
        let that = this;
        axios.post(config.settlementCurrency,{}).then(function(response){
          if(response.data.resultCode  == 1){
            let activeValues = response.data.resultData;
            let arrNews= [];
            for(let i =0 ;i <activeValues.length ;i++){
              let activeName = {
                value:activeValues[i].itemCode,
                label:activeValues[i].itemCname
              }
              arrNews.push(activeName)
            }
            // console.log(arrNews)
            that.settlementCurrency = arrNews;
          }
        })
      },
      // 交货方式
      jiaoHuoFangShi(){
        let that = this;
        axios.post(config.modeofDelivery,{}).then(function(response){
          if(response.data.resultCode  == 1){
            let activeValues = response.data.resultData;
            let arrNews= [];
            for(let i =0 ;i <activeValues.length ;i++){
              let activeName = {
                value:activeValues[i].itemCode,
                label:activeValues[i].itemCname
              }
              arrNews.push(activeName)
            }
            // console.log(arrNews)
            that.deliveryMethod = arrNews;
          }
        })
      },

      // 交货期
      jiaohuoqi(indexs,val){
        // if(val==)
        // if(new Date(val).getDay()==1){
        //     alert(111)
        // }
        this.data4[indexs.index].deliveryDate=val;
        // console.log(val)
        // console.log(new Date(val).getDay())
      },
      tiaozhuan(){
                this.$router.push({name: 'firstpage',params:{ id:'1'}});
            },
      //手填订单确定填写信息
      handMoveWeiHuChengPinTrue(pamar,indexs){
        // console.log(indexs.dataNews)
        let processQueryProductList = [];
        // console.log(pamar)
        // alert(111)
        let that = this;
        that.data4[pamar.index].ifDengFenDisabled = indexs.ifDengFenDisabled;
        let newDataNews = [];
        // for(let i=0;i<indexs.dataNews.length;i++){
          // if(indexs.dataNews[i].prodHeight=="C" ){
          //   if(indexs.dataNews[i].prodWidth==indexs.dataNews[i+1].prodWidth){
          //   // alert(1111)
          //   console.log(indexs.dataNews[i].prodWidth)
          // }
          let arr=[]
          // let arrprodHeight
          // let arrprodprodWidth
          indexs.dataNews.forEach(r=>{
            newDataNews.push(r);
            if(r.prodHeight!="C"){
              arr.push(r)
              // if(arr.indexOf(r.prodWidth)==-1){
              // let arrprodHeight=r.prodHeight
              // let arrprodWidth=r.prodWidth
              // let arrprodQty=r.prodNumber
              // let arrprodOneWeight=r.prodOneWeight
              // let deliveryPlaceCode = r.deliveryPlaceCode?r.deliveryPlaceCode:'';
              
              // console.log(processQueryProductList)
              // processQueryProductList.push({
              //   "prodHeight":arrprodHeight,
              //   "prodWidth":arrprodWidth,
              //   "prodQty":arrprodQty,
              //   "prodOneWeight":arrprodOneWeight,
              //   "deliveryPlaceCode":deliveryPlaceCode

              // })
              // console.log(processQueryProductList)
              // }

            }
            if(r.prodHeight=="C"){
              let newActive = 1;
              arr.forEach((n,index)=>{
                if(n!= undefined&&n.prodHeight!= undefined&&n.prodHeight=="C"&&r.prodWidth == n.prodWidth){
                  arr[index].prodNumber = parseInt(arr[index].prodNumber)+1;
                  newActive = 2;
                }
              })
              if(newActive == 1){
                arr.push(r)
              }
            }

            // r.prodWidth==(r+1).prodWidth;
            // let arr=[]
            // if(arr.length=0){
            //   arr.push(r.prodWidth)
            // }
            // console.log(r+1)
          })
            // console.log(arr)
            // console.log(arr.indexOf)

        // }
          // console.log(indexs.dataNews[i])
        // }
        // let processQueryProductList = [];
        let midu = that.data4[pamar.index].specification.split("*")[0];
        let categoryCode = that.data4[pamar.index].categoryCode;
        let icCategoryId = that.data4[pamar.index].icCategoryId;
        let markId = that.data4[pamar.index].markId;
        let prodWeight = 0;
        // that.dataNewpro=indexs.
        // console.log(indexs.dataNews)
        for(let i = 0; i<arr.length; i++){
          if(arr[i].prodWidth == ''||arr[i].prodWidth =='0'||arr[i].prodWidth == undefined)continue;
          const prodWidth=  arr[i].prodWidth?String(arr[i].prodWidth):0;
          const prodHeight=  arr[i].prodHeight?arr[i].prodHeight:'C';
          const spes =midu +'*'+ prodWidth +'*'+ prodHeight;
          const prodQty = arr[i].prodNumber?arr[i].prodNumber:'';
          const prodOneWeight = arr[i].prodOneWeight?arr[i].prodOneWeight:'';
          const deliveryPlaceCode = arr[i].deliveryPlaceCode?arr[i].deliveryPlaceCode:'';
          prodWeight += prodOneWeight ;
          processQueryProductList.push({
            "spes": spes,
            "categoryCode": categoryCode,
            "prodWeight": prodOneWeight,
            "prodQty": prodQty,
            "icCategoryId":icCategoryId,
            "markId":markId,
            "deliveryPlace":deliveryPlaceCode,
          })
        }
        if(indexs.changeWidth == 'last' && indexs.lastWidth != '0' && !isNaN(indexs.lastWidth)){
          const prodWidth=  indexs.lastWidth;
          const prodHeight=  'C';
          const spes =midu +'*'+ prodWidth +'*'+ prodHeight;
          const prodQty = 1;
          const prodOneWeight = that.data4[pamar.index].processingWeight - prodWeight;
//          const deliveryPlaceCode = indexs.dataNews[i].deliveryPlaceCode?indexs.dataNews[i].deliveryPlaceCode:'';
          processQueryProductList.push({
            "spes": spes,
            "categoryCode": categoryCode,
            "prodWeight": prodOneWeight,
            "prodQty": prodQty,
            "icCategoryId":icCategoryId,
            "markId":markId,
           "deliveryPlace":indexs.shengYuArea,
          })
        }
        // console.log(processQueryProductList);
        that.data4[pamar.index].dataNews = newDataNews;
//        that.data4[pamar.index].dataNews = indexs.dataNews;
        that.data4[pamar.index].residueWidth = indexs.residueWidth;
        that.data4[pamar.index].changeWidth = indexs.changeWidth;
        that.data4[pamar.index].lastWidth = indexs.lastWidth;
        that.data4[pamar.index].shengYuArea = indexs.shengYuArea;
        that.$set(that.data4[pamar.index],"processQueryProductList",processQueryProductList)
        // that.handMoveRemoveNum = '';
        // that.handMoveSearchMaterialWHCP = false;
      },

      //手填订单新增填写信息
      // handMoveWeiHuChengPinAdd(){
      //     console.log(this.data5)
      //     this.data5.push({})
      // },

      //购物车对应的等分数据
      changeDengFen(indexs,a){
        // console.log(a);
        //indexs.row.ifDengFen=a
        this.data2[indexs.index].ifDengFen = a;
        // console.log(this.data2)
      },

      //点击左侧的数据打开相应的表格
      showDingDanTable(datanow,cur){
        // console.log(datanow)
        // console.log(datanow,cur)
        let that = this;
        that.datanows=datanow      
        let paramsData = {
          "customerName":datanow.customerName,
          "categoryCode": datanow.categoryCode,
          "specification": datanow.specification,
          "shopsign": datanow.shopsign,
          "exposed":datanow.exposed,
          "queryFlag":"01"
        }
        let currentTemplate=datanow;
        // console.log()
        that.exposedNum=paramsData.exposed
        // console.log(that.exposedNum)
        // console.log(paramsData.exposed)
        // console.log(this.addDingDanShenQingTable)
        if(this.addDingDanShenQingTable === cur){
          this.addDingDanShenQingTable= 'false';
          that.bgc = false;
          if(this.addDingDanShenQingTable== 'false'){
            that.moredata=true
          }
          // console.log(that.addDingDanShenQingTable)
          // console.log(cur)
        }else{
          axios.post(config.queryStockOnHand,paramsData).then(function(response){
            // console.log(response)
            // console.log(that.bgc)
            if(response.data.resultCode == '1'){
              that.bgc = cur;
              if(response.data.page != null){
                that.moreNumber = response.data.page.totalPageCount;
              }
              response.data.resultData.forEach(r =>{
                r.processingWeight =r.primaryQty
              })
              that.data1=response.data.resultData;
              that.addDingDanShenQingTable= cur;

              // this.data1[params.index].processingWeight = params.row.primaryQty;
            }
            // console.log(that.addDingDanShenQingTable)
          })
        }

        // that.backgroundColor.("blue").siblings().removeClass("blue")

      },

      //打开购物车里面的加载更多按钮
      addMoreShenQingData(datanow){
        let that = this;
        if(that.moreNumber != '' && typeof that.moreNumber == 'number'){
          // console.log(datanow)
          let paramsData = {
            // "categoryCode": datanow.categoryCode,1
            // "specification": datanow.specification,1
            // "shopsign": datanow.shopsign,1
            // "exposed":"20",1
            "offset": that.data1.length,
            "limit":10,
            // "warehouseName" : that.numpinzhong,
            // "serialCode" : that.numpaihao,
            // "stockType" : that.cpyl,
            // "businessType":that.cunhuo,
            // "reelNo":that.numpaihaos,
            // "processingWeight":that.jiagongWeight,
            "customerName":datanow.customerName,
            "categoryCode": datanow.categoryCode,
            "specification": datanow.specification,
            "shopsign": datanow.shopsign,
            "exposed":datanow.exposed,
            "queryFlag":"01"
                // "exposed"=that.exposedNum;
          }
          // console.log(that.datanow)
            if(that.moredata==true){
                that.$Message.info({
                  content:language.qingshaodeng,
                  duration: 5
              })

            }
            // console.log(that.data)
          if(that.data1.length%10 != 0){ that.moredata=false;that.$Message.destroy(); return;}
          if(that.moreNumber%10 == 0 && that.data1.length == that.moreNumber){ that.moredata=false;that.$Message.destroy();return;}
          axios.post(config.queryStockOnHand,paramsData).then(function(response){
            // console.log(response)
            // response.data.resultData.forEach(r =>{
            //     r.processingWeight =r.primaryQty
            //   })
            if(response.data.resultCode==1){
                that.$Message.destroy()
                that.data1 = that.data1.concat(response.data.resultData);

                response.data.resultData.forEach(r =>{
                r.processingWeight =r.primaryQty
              })
                // console.log(that.data1)
                // that.$Message.info(response.data.fsuffix)
            }
            


          })
            .catch(function (error) {
              // console.log(error)
            });
        }
      },

      //添加到购物车数据加工重量
      addCarDataOne(indexs,a){
        console.log(indexs,+"1111111"+a)
        this.data1[indexs.index].processingWeight = a;
        // this.jiagongWeight=a
        // console.log(a)
        // console.log(this.data1)
      },


      //手填加工填写宽度
      // addWidthDataFive(indexs,a){      //     let that = this;

      //     that.data5[indexs.index].prodWidth = parseInt(a);
      //     console.log(that.data5[indexs.index].prodWidth)
      //     //if(that.data5[indexs.index].prodWidth != '' && that.data5[indexs.index].prodHeight == 'C'){
      //         //let primaryQty = that.data4[that.handMoveRemoveNum].primaryQty;
      //         //let allWidth = 0;
      //         //for (let i = 0; i<that.data5.length; i++){
      //         //    allWidth +=that.data5[i].prodWidth;
      //         //}
      //         //console.log(allWidth)
      //         //that.data5[indexs.index].prodOneWeight =
      //     //}
      // },


      // //手填加工填写长度
      // addHeightDataFive(indexs,a){
      //     console.log(indexs,a)
      //     this.data5[indexs.index].prodHeight = a;
      // },

      // //手填加工数量
      // addNumDataFive(indexs,a){
      //     console.log(indexs,a)
      //     this.data5[indexs.index].prodNumber = a
      // },

      // //手填加工数量
      // addActionDataFive(indexs,a){
      //     console.log(indexs,a)
      //     this.data5[indexs.index].deliveryPlace = a
      // },

      //购物车数据加工重量
      addCarDataTwo(indexs,a){
        // console.log(indexs,a)
        this.data2[indexs.index].processingWeight = a;
        this.showSubmitCarNews= true;
        if(parseInt(indexs.row.primaryQty)<parseInt(a)){
          this.$Message.info(language.jiagongzhongliangdayuzhongliang)
          this.showSubmitCarNews= false;
        }

        // console.log(this.data2)
      },
      // 手填加工重量
      shoutian(indexs,a){
        let that = this;
//        this.data4[indexs.index].processingWeight=a;
        that.$set(that.data4[indexs.index],"processingWeight",parseInt(a))
//         console.log(that.data4)
        let numbersAll = that.data4[indexs.index].specification.split('*');
        let computedLength = Number(that.data4[indexs.index].processingWeight)*1000000/Number(numbersAll[0])/Number(numbersAll[1])/Number(that.data4[indexs.index].density);
        if(that.data4[indexs.index].dataNews!= undefined && that.data4[indexs.index].dataNews!= null && that.data4[indexs.index].dataNews.length>0){
          for(let i =0;i<that.data4[indexs.index].dataNews.length;i++){
            if(that.data4[indexs.index].dataNews[i].prodHeight == 'C'){
              that.data4[indexs.index].dataNews[i].prodNumber = 1;
              that.data4[indexs.index].dataNews[i].prodOneWeight= Math.floor(Number(numbersAll[0])*Number(that.data4[indexs.index].dataNews[i].prodWidth)*computedLength*Number(that.data4[indexs.index].density)/1000000)
              // that.residueWidth = parseInt(numbersAll[1]) - parseInt(a);
            }
            if(that.data4[indexs.index].dataNews[i].prodHeight != 'C' && that.data4[indexs.index].dataNews[i].prodHeight != ''){
              that.data4[indexs.index].dataNews[i].prodNumber = Math.floor(computedLength/Number(that.data4[indexs.index].dataNews[i].prodHeight));
              // that.dataNews[indexs.index].prodNumber = 1;
              that.data4[indexs.index].dataNews[i].prodOneWeight= Math.floor(that.data4[indexs.index].dataNews[i].prodNumber*Number(numbersAll[0])*Number(that.data4[indexs.index].dataNews[i].prodWidth)*Number(that.data4[indexs.index].dataNews[i].prodHeight)*Number(that.data4[indexs.index].density)/1000000);
              // that.residueWidth = parseInt(numbersAll[1]) - parseInt(a);
            }
          }
          if(that.data4[indexs.index].lastWidth == '0' && that.data4[indexs.index].residueWidth != null && that.data4[indexs.index].residueWidth != '' && that.data4[indexs.index].residueWidth != 0){
            let allWidth =[];
            let allWeight = [];
            that.data4[indexs.index].dataNews.forEach((item,index)=>{
              allWidth.push(item.prodWidth);
              allWeight.push(item.prodOneWeight);
            })
            let weight = 0;
            allWeight.forEach((item,index)=>{
              weight += item
            })
            let width =0;
            allWidth.forEach((item,index)=>{
              width += item
            })
            const lastWeight = Number(that.data4[indexs.index].processingWeight) - weight;
            const oneWeight = lastWeight/width;
            let newWeight = 0;
            for(let i = 0; i<that.data4[indexs.index].dataNews.length-1;i++){
              newWeight +=parseInt(oneWeight*that.data4[indexs.index].dataNews[i].prodWidth+that.data4[indexs.index].dataNews[i].prodOneWeight);
              that.data4[indexs.index].dataNews[i].prodOneWeight = parseInt(oneWeight*that.data4[indexs.index].dataNews[i].prodWidth+that.data4[indexs.index].dataNews[i].prodOneWeight);
            }
            that.data4[indexs.index].dataNews[that.data4[indexs.index].dataNews.length-1].prodOneWeight = Number(that.data4[indexs.index].processingWeight) -newWeight
          }
          that.handMoveWeiHuChengPinTrue(indexs,that.data4[indexs.index])
        }
      },
      
      //添加到购物车
      addCars(indexs){
        let processingWeight=this.jiagongzhongliang;
        if(processingWeight=='' || processingWeight==null)
        {
          processingWeight=this.data1[indexs.index].processingWeight
        }
        let paramsData= {
          "warehouseName": this.data1[indexs.index].warehouseName,
          "categoryCode": this.data1[indexs.index].categoryCode,
          "shopsign": this.data1[indexs.index].shopsign,
          "specification": this.data1[indexs.index].specification,
          "primaryQty": this.data1[indexs.index].primaryQty,
          "processingWeight": processingWeight,
          "serialCode": this.data1[indexs.index].serialCode,
          //"ifDengFen": "true",
          "deliveryDate": this.data1[indexs.index].deliveryDate,
          "templateCode": this.templateList[this.addDingDanShenQingTable].templateCode,
          "templateName": this.templateList[this.addDingDanShenQingTable].templateName,
          "template": this.templateList[this.addDingDanShenQingTable],
          "rawId": this.templateList[this.addDingDanShenQingTable].rawId,
          "processQueryProductList":this.templateList[this.addDingDanShenQingTable].productList,
          // "firstNumbers":this.templateList[this.addDingDanShenQingTable].firstNumbers,
          "stockInDate":this.data1[indexs.index].stockInDate,
          "rollPath":this.data1[indexs.index].rollPath,
          "exposed":this.data1[indexs.index].exposed,
          "reelNo":this.data1[indexs.index].reelNo,
          "density":this.data1[indexs.index].density,
          // "firstNumbers":this.templateList[this.addDingDanShenQingTable].processQueryProductList.firstNumbers,
          // "firstWidth":this.templateList[this.addDingDanShenQingTable].processQueryProductList.firstWidth,
          //"orderNo":this.data1[indexs.index].orderNo
        }
        //重新置空
        processingWeight='';
        this.jiagongzhongliang=''
        console.log(this.data1[indexs.index].processingWeight)
        console.log(this.data1[indexs.index])

        function isNumber(val) {
          let regPos = /^\d+(\.\d+)?$/; //非负浮点数
          let regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
          if(regPos.test(val) || regNeg.test(val)) {
            return true;
          } else {
            return false;
          }
        }
        // if(this.data1[indexs.index].processingWeight == undefined || this.data1[indexs.index].processingWeight == ''){
        //   this.$Message.info(language.qingtianxiejiagongzhongliang);return
        // }
        if(parseInt(this.data1[indexs.index].processingWeight) > parseInt(this.data1[indexs.index].primaryQty)){
          this.$Message.info(language.jiagongzhongliangdayuzhongliang);return
        }
        // if(!isNumber(this.data1[indexs.index].processingWeight)){
        //   this.$Message.info(language.qingtianxiezhengquedejiagongzhongliang);return
        // }
        let that = this;
        axios.post(config.addCart,paramsData).then(function(response){
          that.showCar();
          if(response.data.resultCode==1){
            that.$Message.info(language.jiarugouwuchechenggong)
          }
            else if(response.data.resultCode==0){
            that.$Message.info(response.data.resultMsgDetail)

            }
          
        }).catch(function(err){
          console.log(err)
        })
        // console.log(this.templateList[this.addDingDanShenQingTable])
          // console.log(this.templateList[this.addDingDanShenQingTable]).firstNumbers
      },


      //手填加工添加到购物车
      // data4是本列表
      addHandMoveCars(indexs){
        // console.log(indexs)
        if(indexs.row.density == null || indexs.row.density ==undefined){
          this.$Message.info({
            content:language.gaikunbaomeiyoumiduwufatianjia,
            duration: 3
          });
          return
        }
        function AddDays(dayIn) {
          let date=new Date();
          let myDate=new Date(date.getTime()+dayIn*24*60*60*1000);
          let year=myDate.getFullYear();
          let month=myDate.getMonth()+1;
          let day=myDate.getDate();
          let CurrentDate=year+"-";
          if(month>=10){
            CurrentDate=CurrentDate+month+"-";
          }else{
            CurrentDate=CurrentDate+"0"+month+"-";
          }
          if(day>=10){
            CurrentDate=CurrentDate+day;
          }else{
            CurrentDate=CurrentDate+"0"+day;
          }
          return CurrentDate;
        }
        let moRenDate = AddDays(0);
        // console.log(new Date(moRenDate).getDay())
        if(new Date(AddDays(0)).getDay()==1||new Date(AddDays(0)).getDay()==7){
            moRenDate = AddDays(4);
        }else if(new Date(AddDays(0)).getDay()==6){
            moRenDate = AddDays(5);
        }else{
            moRenDate = AddDays(6);
        }
        this.handMoveSearchMaterial = true;
        // console.log(indexs)
        let addHandMoveCarSerialCode = indexs.row.serialCode;
        let serialCode = 0;

        if(this.data4.length == 0){
          this.$Message.info(language.jiaruweihuchengpinchenggong)
          this.data4.push(this.data3[indexs.index]);
          this.$set(this.data4[0],"processingWeight",this.data4[0].primaryQty);
//          this.data4[0].processingWeight = this.data4[0].primaryQty;
          for(let i=0;i<this.queryClearinguser.length;i++){
            if(this.queryClearinguser[i].value=='461'){
              // console.log(this.queryClearinguser.value)
              this.data4[0].settlementUser=this.queryClearinguser[i] != undefined?this.queryClearinguser[i].value :this.queryClearinguser[0] != undefined?this.queryClearinguser[0].value:[];
              // this.data4[1].settlementUser=this.queryClearinguser[i] != undefined?this.queryClearinguser[i].value :this.queryClearinguser[0] != undefined?this.queryClearinguser[0].value:[];
          this.data4[0].settlementUserName=this.queryClearinguser[i] != undefined?this.queryClearinguser[i].label :this.queryClearinguser[0] != undefined?this.queryClearinguser[0].label:[];
          // this.data4[1].settlementUserName=this.queryClearinguser[i] != undefined?this.queryClearinguser[i].label :this.queryClearinguser[0] != undefined?this.queryClearinguser[0].label:[];
            }
            // console.log(this.queryClearinguser)
          }
          
          // this.data4[0].settlementUser=this.queryClearinguser[2] != undefined?this.queryClearinguser[2].value:this.queryClearinguser[0] != undefined?this.queryClearinguser[0].value:[];
          this.data4[0].deliveryMethod=this.deliveryMethod[1] != undefined?this.deliveryMethod[1].value:this.deliveryMethod[0] != undefined?this.deliveryMethod[0].value:[];
          this.data4[0].deliveryMethodName=this.deliveryMethod[1] != undefined?this.deliveryMethod[1].label:this.deliveryMethod[0] != undefined?this.deliveryMethod[0].label:[];
          this.data4[0].deliveryDate = moRenDate;
          for(var i=0;i<this.data4.length;i++){
          this.data4[i].settlementCurrency=this.settlementCurrency[1].value;
          this.data4[i].settlementCurrencyName=this.settlementCurrency[1].label;
          }
          return;
        }
        for (let i=0;i<this.data4.length;i++){
          if(this.data4[i].serialCode== addHandMoveCarSerialCode){
            serialCode =1;
          }
        }
        if(serialCode == 1){
          this.$Message.info(language.yuanliaoyicunzaiqingweihuchengpinxinxi);return
        }
        let activeItem = [];
        activeItem.push(this.data3[indexs.index])
//        activeItem[0].processingWeight = activeItem[0].primaryQty;
        this.$set(activeItem[0],"processingWeight",activeItem[0].primaryQty);
        // for(let i=0;i<this.queryClearinguser.length;i++){
        //     if(this.queryClearinguser[i].value=='461'){
            
        //     }
        //     console.log(this.queryClearinguser)
        //   }
        // 这里
        for(let i=0;i<this.queryClearinguser.length;i++){
            if(this.queryClearinguser[i].value=='461'){
              activeItem[0].settlementUser=this.queryClearinguser[i].value;
              activeItem[0].settlementUserName=this.queryClearinguser[i].label;
            }
            if(this.queryClearinguser[i].value!='461'){
              activeItem[0].settlementUser=this.queryClearinguser[0].value;
              activeItem[0].settlementUserName=this.queryClearinguser[0].label;
            }
            // console.log(this.queryClearinguser)
          }
        // for(let i=0;i<this.queryClearinguser.length;i++){
        //     if(this.queryClearinguser[i].value!='461'){
        //       activeItem[0].settlementUser=this.queryClearinguser[0].value;
        //       activeItem[0].settlementUserName=this.queryClearinguser[0].label;
        //     }
        //     // console.log(this.queryClearinguser)
        //   }
        
        // for(var i=0;i<this.data4.length;i++){
          activeItem[0].settlementCurrency=this.settlementCurrency[1].value;
          activeItem[0].settlementCurrencyName=this.settlementCurrency[1].label;
         // for(let i=0;i<this.queryClearinguser.length;i++){
         //    if(this.queryClearinguser[i].value=='461'){
         //      activeItem[0].settlementUser=this.queryClearinguser[i].value;
         //    }
         //    // console.log(this.queryClearinguser)
         //  }

          // }
        activeItem[0].deliveryMethod=this.deliveryMethod[1].value;
        activeItem[0].deliveryDate = moRenDate;
        this.data4.push(activeItem[0])
      },


      //手填加工删除购物车
      removrHandMove(indexs){
        // console.log(indexs)
        this.data4.splice(indexs.index,1)
        // if(indexs.index == this.handMoveRemoveNum){
        //     this.handMoveRemoveNum = '';
        //     // this.data5 = [{}];
        //     // this.handMoveSearchMaterialWHCP = false;
        // }
      },


      // //手填加工删除填写信息
      // removeDataFive(indexs){
      //     this.data5.splice(indexs.index,1)
      // },

      //同上交货期
      againDeliveryDate(indexs){
        console.log(indexs)
        let that = this;
        for(let i=1;i<that.data2.length;i++){
          that.data2[i].deliveryDate = that.data2[0].deliveryDate;
        }
      },

      //撤销删除购物车
      removeCar(indexs){
        // console.log(indexs)
        let that = this;
        let paramsData = new FormData();
        paramsData.append("serialCode", indexs.row.serialCode);
        // console.log(paramsData)
        const instance = axios.create({
        withCredentials: true
        })
        instance.post(config.deleteCart,paramsData).then(function(response){
          // console.log(response)
          if(response.data.resultCode  === '1'){
            that.data2.splice(indexs.index,1)
          }
          //that.data2 = response.data.resultData;
        })
          .catch(function (error) {
            console.log(error)
          });
      },

      //提交购物车数据
      submitAddCar(){
        let that = this;
        if(that.showSubmitCarNews=== false){
          this.$Message.info(language.qingtianxiezhengquedejiagongzhongliang);return
        }
        const deliveryDate = that.data2.map(item=>{
          // console.log(item.deliveryDate)
          if(item.deliveryDate == null || item.deliveryDate == ''){
            return false
          }
          return true
        })
        for(let i =0;i<deliveryDate.length;i++){
          if(deliveryDate[i] == false){
            this.$Message.info(language.qingxuanzejiaohuoqi);return
          }
        }
        if(that.showSubmitCarNews=== false){
          this.$Message.info(language.qingxuanzejiaohuoqi);return
        }
        if(that.data2.length>0){
          for(let i=0;i<that.data2.length;i++){
            if(that.data2[i].ifDengFen==true){
            for(let j=0;j<that.data2[i].processQueryProductList.length;j++){
            // console.log(that.data2[i].processQueryProductList[j].prodQty)
            // console.log(that.data2[i].processQueryProductList[j].prodWeight)
            that.data2[i].processQueryProductList[j].prodQty=that.data2[i].processQueryProductList[j].prodQty*2
            that.data2[i].processQueryProductList[j].prodWeight=that.data2[i].processQueryProductList[j].prodWeight/2
            }
          }
          }
          let paramsData= {
            shopCartTemplateList:that.data2
          }
          axios.post(config.submitApply,paramsData).then(function(response){
            // console.log(response)
            if(response.data.resultCode == 0){
              that.$Message.info(response.data.fsuffix);
            }
            if(response.data.resultCode == 1){
              that.data2  = []
              that.$Message.info(language.caozuochenggong);
            }
          })
            .catch(function (error) {
              // console.log(error)
            });
        }else{
          that.$Message.info(language.qingtianjiagouwuche);
        }

      },

      //手填加工提交购物车数据
      submitTemporaryAddCar(indexs){
        console.log(111111);
        this.isDisabled = true;
        let that = this;
        if(that.data4.length>0){
          console.log(that)
            for(let i=0;i<that.data4.length;i++){
            if(that.data4[i].ifDengFen==true){
            for(let j=0;j<that.data4[i].processQueryProductList.length;j++){

            that.data4[i].processQueryProductList[j].prodQty=that.data4[i].processQueryProductList[j].prodQty*2
            that.data4[i].processQueryProductList[j].prodWeight=that.data4[i].processQueryProductList[j].prodWeight/2
            }
          }
          }
          
          let newArr = [];
          that.data4.forEach(r=>{
            if(r.processQueryProductList == undefined || r.processQueryProductList == null)
            // console.log(r)
                newArr.push(r.serialCode)
          })
          if(newArr.length>0){
            that.$Modal.info({
              content:language.kunbao+newArr+language.weiweihuchengpinbunengtijiao,
              duration: 3
            });
            this.isDisabled = false;
            return;
          }
          let paramsData= {
            shopCartTemplateList:that.data4,
          }
          //解决连续点击发生两次请求的问题
            axios.post(config.submitApply,paramsData).then(function(response){
            
              if(response.data.resultCode == 0){
                that.$Message.info(response.data.fsuffix);
              }
              if(response.data.resultCode == 1){
                that.handMove = false;
                that.data4 = [];
              }
              that.isDisabled = false;

            })
              .catch(function (error) {
                console.log(error)
              });
        }
      },

      //暂存购物车数据
      // submitTemporaryAddCar(indexs){
      //     let that = this;
      //     let paramsData= {
      //         remarks: that.handMoveRemark,
      //         shopCartTemplateList:that.data4
      //     }
      //     console.log(indexs)
      //     if(indexs == 1){
      //         axios.post(config.submitApply,paramsData).then(function(response){
      //             console.log(response)
      //             if(response.data.resultCode == 0){
      //                 that.$Message.info(response.data.fsuffix);
      //             }
      //             if(response.data.resultCode == 1){
      //                 that.data2 = []
      //             }
      //         })
      //         .catch(function (error) {
      //             console.log(error)
      //         });
      //     }
      //     if(indexs == 2){
      //         axios.post(config.temporaryStorage,paramsData).then(function(response){
      //             console.log(response)
      //             if(response.data.resultCode == 0){
      //                 that.$Message.info(response.data.fsuffix);
      //             }
      //             if(response.data.resultCode == 1){
      //             }
      //         })
      //         .catch(function (error) {
      //             console.log(error)
      //         });
      //     }
      // },
      //购物车打开获取数据
      showSubmitCar(){
        let that = this;
        that.submitCar = true;
        axios.post(config.queryCart).then(function(response){
          // console.log(response.data.resultData[0].specification)
          // response.data.resultData=response.data
          response.data.resultData.forEach(r=>{

            // console.log(r.specification)
            that.l=r.specification.split('*')
            that.chengpinnum.push(r)
          })
          // console.log(response,"11")
          // console.log(that.chengpinnum)
          // that.chengpinnum.processQueryProductList.forEach(m=>{
          //   console.log(m)
          //    that.p=m.spes.split("*")
          // })
          for(let j=0;j<response.data.resultData.length;j++){
            for(let k=0;k<response.data.resultData[j].processQueryProductList.length;k++){
              // console.log(response.data.resultData[j].processQueryProductList[k])
              if(response.data.resultData[j].specification==response.data.resultData[j].processQueryProductList[k].spes){
                response.data.resultData[j].dengfenIf=true
              }
            }
            // console.log(response.data.resultData[j])
          }
        
          // if(that.p[1]==that.l[1]){
          //   that.chengpinnum.dengfenIf=true
          // }
          const dataTwo = response.data.resultData == null?[]:response.data.resultData;
          that.data2 = dataTwo;
          if(that.data2.length>0){
            function AddDays(dayIn) {
                        // that.ifpackaged();
                        // that.storagessd();
                        let date=new Date();
                        let myDate=new Date(date.getTime()+dayIn*24*60*60*1000);
                        let year=myDate.getFullYear();
                        let month=myDate.getMonth()+1;
                        let day=myDate.getDate();
                        let CurrentDate=year+"-";
                        if(month>=10){
                            CurrentDate=CurrentDate+month+"-";
                        }else{
                            CurrentDate=CurrentDate+"0"+month+"-";
                        }
                        if(day>=10){
                            CurrentDate=CurrentDate+day;
                        }else{
                            CurrentDate=CurrentDate+"0"+day;
                        }
                        return CurrentDate;
                            }
                        let moRenDate = AddDays(0);
                        // console.log(new Date(moRenDate).getDay())
                        if(new Date(AddDays(0)).getDay()==1||new Date(AddDays(0)).getDay()==7){
                            moRenDate = AddDays(4);
                        }else if(new Date(AddDays(0)).getDay()==6){
                            moRenDate = AddDays(5);
                        }else{
                            moRenDate = AddDays(6);
                        }
                          // let moRenDate = AddDays(4);
                          for(let i=0 ;i<that.data2.length;i++){
                                that.data2[i].deliveryDate = moRenDate;
                              }
          }
          // console.log(response)
          if(response.data.resultCode==0){
            // alert(111)
            that.$Modal.error({title:language.cuowu,content:response.data.resultMsgDetail})
          }
          // console.log(11111)
//          function AddDays(dayIn) {
//            let date=new Date();
//            let myDate=new Date(date.getTime()+dayIn*24*60*60*1000);
//            let year=myDate.getFullYear();
//            let month=myDate.getMonth()+1;
//            let day=myDate.getDate();
//            let CurrentDate=year+"-";
//            if(month>=10){
//              CurrentDate=CurrentDate+month+"-";
//            }else{
//              CurrentDate=CurrentDate+"0"+month+"-";
//            }
//            if(day>=10){
//              CurrentDate=CurrentDate+day;
//            }else{
//              CurrentDate=CurrentDate+"0"+day;
//            }
//            return CurrentDate;
//          }
//          let moRenDate = AddDays(4);
        })
          .catch(function (error) {
            console.log(error)
          });
        //console.log(111);
      },

//获取购物车数据
      showCar(){
        let that = this;
        //that.submitCar = true;
        axios.post(config.queryCart).then(function(response){
          // console.log(response.data.resultData[0].specification)
          // response.data.resultData=response.data
          response.data.resultData.forEach(r=>{

            // console.log(r.specification)
            that.l=r.specification.split('*')
            that.chengpinnum.push(r)
          })
          // console.log(response,"11")
          // console.log(that.chengpinnum)
          // that.chengpinnum.processQueryProductList.forEach(m=>{
          //   console.log(m)
          //    that.p=m.spes.split("*")
          // })
          for(let j=0;j<response.data.resultData.length;j++){
            for(let k=0;k<response.data.resultData[j].processQueryProductList.length;k++){
              // console.log(response.data.resultData[j].processQueryProductList[k])
              if(response.data.resultData[j].specification==response.data.resultData[j].processQueryProductList[k].spes){
                response.data.resultData[j].dengfenIf=true
              }
            }
            // console.log(response.data.resultData[j])
          }
        
          // if(that.p[1]==that.l[1]){
          //   that.chengpinnum.dengfenIf=true
          // }
          const dataTwo = response.data.resultData == null?[]:response.data.resultData;
          that.data2 = dataTwo;
          if(that.data2.length>0){
            function AddDays(dayIn) {
                        // that.ifpackaged();
                        // that.storagessd();
                        let date=new Date();
                        let myDate=new Date(date.getTime()+dayIn*24*60*60*1000);
                        let year=myDate.getFullYear();
                        let month=myDate.getMonth()+1;
                        let day=myDate.getDate();
                        let CurrentDate=year+"-";
                        if(month>=10){
                            CurrentDate=CurrentDate+month+"-";
                        }else{
                            CurrentDate=CurrentDate+"0"+month+"-";
                        }
                        if(day>=10){
                            CurrentDate=CurrentDate+day;
                        }else{
                            CurrentDate=CurrentDate+"0"+day;
                        }
                        return CurrentDate;
                            }
                        let moRenDate = AddDays(0);
                        // console.log(new Date(moRenDate).getDay())
                        if(new Date(AddDays(0)).getDay()==1||new Date(AddDays(0)).getDay()==7){
                            moRenDate = AddDays(4);
                        }else if(new Date(AddDays(0)).getDay()==6){
                            moRenDate = AddDays(5);
                        }else{
                            moRenDate = AddDays(6);
                        }
                          // let moRenDate = AddDays(4);
                          for(let i=0 ;i<that.data2.length;i++){
                                that.data2[i].deliveryDate = moRenDate;
                              }
          }
          // console.log(response)
          if(response.data.resultCode==0){
            // alert(111)
            that.$Modal.error({title:language.cuowu,content:response.data.resultMsgDetail})
          }
          // console.log(11111)
//          function AddDays(dayIn) {
//            let date=new Date();
//            let myDate=new Date(date.getTime()+dayIn*24*60*60*1000);
//            let year=myDate.getFullYear();
//            let month=myDate.getMonth()+1;
//            let day=myDate.getDate();
//            let CurrentDate=year+"-";
//            if(month>=10){
//              CurrentDate=CurrentDate+month+"-";
//            }else{
//              CurrentDate=CurrentDate+"0"+month+"-";
//            }
//            if(day>=10){
//              CurrentDate=CurrentDate+day;
//            }else{
//              CurrentDate=CurrentDate+"0"+day;
//            }
//            return CurrentDate;
//          }
//          let moRenDate = AddDays(4);
        })
          .catch(function (error) {
            console.log(error)
          });
        //console.log(111);
      },
      //手填加工打开维护成品
      // showHandMoveWHCP(indexs){
      //     console.log(indexs)
      //     this.handMoveRemoveNum = indexs.index;
      //     // this.handMoveSearchMaterialWHCP = true;
      // },

      //手填加工打开获取数据
      showHandMove(indexs){
        // console.log(indexs)
        let that = this;
        // let customerName=that.datanows.customerName
        // console.log(customerName)
        let paramsData;
        if(indexs == 1){
          // console.log(that.datanow.customerName)
          paramsData = {
            categoryCode: '',
            specification: '',
            // customerName:customerName,
            shopsign: '',
            "queryFlag":"01",
            // customerName:'',          
          }
          that.handMove = true;
        }
        // console.log(that.datanow)
        if(indexs == 2){
          paramsData = {
            categoryCode: that.handMoveCategoryCode,
            shopsign: that.handMoveSpecification,
            thickness: that.handMoveHeight,
            width: that.handMoveWide,
            length: that.handMoveWidth,
            reelNo: that.mujuantiaojian,
            warehouseName: that.numcangku,
            serialCode: that.kunbaohao,
            categoryCode: that.numpinzhong,
            shopsign: that.numpaihao,
            queryFlag:"01"
            // numpinzhong

          }
        }
        axios.post(config.queryStockOnHand,paramsData).then(function(response){
          // console.log(response)
          if(response.data.resultCode == 1){
            that.data3=response.data.resultData;
            that.data4 = [];
            if(response.data.page != null && response.data.page.totalPageCount != null &&response.data.page.totalPageCount>10){
              that.handMoveDataThree = true;
              that.handMoveDataThreetotalPageCount = response.data.page.totalPageCount;
              // that.$Message.info(response.data.fsuffix)
            }
          }
        })
          .catch(function (error) {
            console.log(error)
          });
      },
      //手填加工表格加载更多
      handMoveDataThreeMore(){
        let that = this;
        if(that.handMoveDataThreetotalPageCount != '' && typeof that.handMoveDataThreetotalPageCount == 'number'){
          let paramsData = {
            "categoryCode": that.handMoveCategoryCode,
            "shopsign": that.handMoveSpecification,
            "thickness": that.handMoveHeight,
            "width": that.handMoveWide,
            "length": that.handMoveWidth,
            "reelNo": that.mujuantiaojian,
            "warehouseName": that.numcangku,
            "offset": that.data3.length,
            "serialCode": that.kunbaohao,
            "categoryCode": that.numpinzhong,
            "shopsign": that.numpaihao,
            "limit":10,
            "queryFlag":"01"
          }
          if(that.data3.length%10 != 0){ that.handMoveDataThree=false; return;}
          if(that.handMoveDataThreetotalPageCount%10 == 0 && that.data3.length == that.handMoveDataThreetotalPageCount){ that.handMoveDataThree=false; return;}
          axios.post(config.queryStockOnHand,paramsData).then(function(response){
            // console.log(response)
            that.data3 = that.data3.concat(response.data.resultData);
            that.$Message.info(language.jiazaiwanbi)
            
          })
            .catch(function (error) {
              console.log(error)
            });
        }
      },

      //关闭购物车
      closeSubmitCar(){
        this.submitCar = false;
      },

      //关闭手填加工
      closehandMoveCar(){
        this.handMove = false;
      },

      //打开页面加载数据
      getMoreData(){
        let that = this;
        let paramsData={
          queryFlag:"01",
          // nopage:"true"
        }
        that.language=language
        that.$Message.info({
          content:language.shujujiazaiqingshaodeng,
                    duration: 20

        })

        axios.post(config.queryTemplate,paramsData).then(function(response){
          // console.log(response)
          if(response.data.resultCode == 1){
            that.templateList = response.data.resultData
            that.$Message.destroy()
          }
        })
          .catch(function (error) {
            console.log(error)
          });
      that.jiesuan();
      that.jiesuans();
      that.fangshi();
      that.jiaoHuoFangShi();
      that.selectType()
      that.shopsignDrop()
      that.warehouseNameDrop()
        //console.log(111);

      },
       chongzhis(){
                let that = this;
                // console.log(that.numpinzhong)
                that.numpinzhong="";
                that.numpaihao="";
                that.cpyl="";
                that.numhou="";
                that.numchang="";
                that.numkuan="";
                that.numcangku="";
                that.numkunbaohao="";
                that.cunhuo="";
                that.numpaihaos="";
                that.exposedNum="";
                that.mujuanhaos="";
                // if(that.chongzhi==true){
                //     params.value=""
                // }
            },

            srechEve(){
              // let that = this;
              this.raval=true
              // console.log(isNaN(that.addDingDanShenQingTable))
              // if(that.addDingDanShenQingTable == 'false'){
              //   // console.log(111)
              //   that.raval=true
              //   // that.$Message.info("请选择模板然后搜索")
              // }
              // if(that.addDingDanShenQingTable != 'false'){
              //   that.raval=true
              // }
              // if(that.addDingDanShenQingTable==true){
              //   that.raval=true
              // }
                // alert("aaa")
                //   let that = this;
                // console.log(that.bgc)
                // if(that.bgc>=0){
                //     that.$Message.info("模板展开")
                //   that.raval=true
                //   console.log(that.bgc)
                // } else if(that.bgc=false){
                //   that.raval=false
                // }

            },
            chaxun(){
                // alert(111)
                // console.log(t)
                let that = this;
                // console.log(that.currentTemplate)
                let params={};
                params.customerId = that.numpinzhong;
                params.categoryCode = that.numpaihao;
                params.shopsign = that.cpyl;
                params.specification=that.cunhuo;
                params.spes=that.numpaihaos;
                params.queryFlag = '01';
                params.exposed=that.exposedNum;
                params.nopage = 'true';

        // that.exposedNum=paramsData.exposed
                // exposed=that.exposedNum;
                // params.customerName=that.datanow.customerName;
                // params.categoryCode= that.datanow.categoryCode;
                // params.specification= that.datanow.specification;
                // params.shopsign= that.datanow.shopsign;
                // params.exposed="20";
          // "queryFlag":"01"
                axios.post(config.queryTemplate,params).then(function(response){
                    // console.log(response)
                    if(response.data.resultCode==1){
                        that.numnum=response.data.page.totalPageCount
                        // console.log(response)
                        that.templateList=response.data.resultData;
                        // alert(111)
                    // console.log(that.numbewdata)
                    // alert(111)
                    that.raval=false
                    that.$Message.info(language.chaxunchenggong)
                    }else if(response.data.resultCode==0){
                      that.raval=false
                      that.$Message.info(response.data.fsuffix)
                    }
                    // console.log(that.row.gcresourceCode)
                    that.addDingDanShenQingTable= false;
                })

            },
    },
    mounted(){
      this.getMoreData();

    },
    watch: {
      'data4':{
        handler: function (newVal,oldVal) {
          // console.log(newVal,oldVal)
//          this.data4.processingWeight= newVal;
//          this.addWidthDataFiveNew()
        },
        deep: true
      }
    },

  }
</script>



// WEBPACK FOOTER //
// addDingDan.vue?16206cab